
/** 
*@author: Sirisha.M
*@Description : This component is mainly for creating failure Report and get list of Failure reports and Failure Analysis
**/
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import moment from 'moment';
// import FileBase64 from './FileBase64';
import {
  Button, Input, Tabs, Form, Select, DatePicker, Row,
  Col, Upload, message, Modal, Tooltip, Drawer, Space, Collapse, Popconfirm
} from 'antd';
import HierarchyModal from './HierarchyModal';
import {
  getHierarchyTreeData,
  // DeleteAttachment,
  onReportManagerAction,
  getDeviceList,
  getUserHeirarchyData,
  submitReport,
  updateReport,
  createAssign,
  createFailure,
  updateFailure,
  createCorrectiveActions,
  updateCorrectiveActions,
  DeleteAttachment
} from './ChartCalls';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { SearchOutlined, QuestionCircleOutlined, UploadOutlined, UpSquareOutlined, EditOutlined, RollbackOutlined, PlusOutlined, EyeOutlined, DownloadOutlined, MinusCircleOutlined, DeleteOutlined, CloudUploadOutlined } from '@ant-design/icons';
// import { translation } from '../../commons/translation';
const { TextArea } = Input;
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StyledHomepage } from '../../../commons/styles/layout';
import { API_FRACAS ,IPAddress} from '../../../commons/api';
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;
const FailureReports = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState('List');
  const [parentPresentActiveKey, setParentPresentActiveKey] = useState('Reporting');

  const [formObject, setFormObject] = useState({});
  const [analysisFormObject, setAnalysisFormObject] = useState({});
  const [correctiveFormObject, setCorrectiveFormObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [devicesList, setDevicesList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [checkedValue, setCheckedValue] = useState(null);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [questionsList, setQuestionsList] = useState([]);
  const [Questions, setQuestions] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [dataSourceForAnalysis, setDataSourceForAnalysis] = useState([]);
  const [dataSourceForManager, setDataSourceForManager] = useState([]);
  const [FailureTypeList, setFailureTypeList] = useState([]);
  const [FailureCodeList, setFailureCodeList] = useState([]);

  const [SeverityList, setSeverityList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [userList, setUserList] = useState([]);

  const [questionsData, setQuestionsData] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(null);
  const [questionVisible, setQuestionVisible] = useState(false);
  const [showusecasedownloadModal, setShowusecasedownloadModal] = useState(false);
  const [analysisShowusecasedownloadModal, setAnalysisShowusecasedownloadModal] = useState(false);

  const [correctiveShowusecasedownloadModal, setCorrectiveShowusecasedownloadModal] = useState(false);
  const [userDepartmentId, setUserDepartmentId] = useState(null);
  // const [checked, setChecked] = useState(false);
  const [selectedKey, setSelectedKey] = useState('');
  const [selectedRolesList, setSelectedRolesList] = useState([]);
  const [selectedTabObj, setSelectedTabObj] = useState({});
  const [statusList, setStatusList] = useState([]);
  const [RoleId, setRoleId] = useState(null);
  const [status, setStatus] = useState(null);
  const [correctiveStatus, setCorrectiveStatus] = useState(null);
  const [correctiveButton, setCorrectiveButton] = useState(false);
  const [failureText, setFailureText] = useState('');
  const [failureAnalysisText, setFailureAnalysisText] = useState('');
  const [current, setCurrent] = useState(1);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedDepartments, setSelectedDepartments] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(null);


  const h1Ref = useRef(null);
  const h2Ref = useRef(null);
  const h3Ref = useRef(null);
  const h4Ref = useRef(null);
  const [form1] = Form.useForm();
  const [form3] = Form.useForm();
  const [form2] = Form.useForm();
  const [form4] = Form.useForm();
  const [form_Manager1] = Form.useForm();
  const [form_Manager2] = Form.useForm();
  const [form_Manager3] = Form.useForm();


  const [QuestionRef] = Form.useForm();
  const myRef = useRef(null);
  const myRef1 = useRef(null);
  const myRef2 = useRef(null);

  // const QuestionRef = useRef(null);

  const searchInput = useRef(null);
  const failureInput = useRef(null);
  const failureAnalysisInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let devicesList = await getDeviceList();
      setDevicesList(devicesList);
      let HierarchyData = await getUserHeirarchyData();
      let RoleId = JSON.parse(localStorage.get('roleId'));
      setRoleId(RoleId);
      let permissionsArray =
        HierarchyData &&
        HierarchyData['belongsTo'] &&
        HierarchyData['belongsTo']['sites'] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];

      let DepartmentId =
        HierarchyData &&
        HierarchyData['user'] &&
        HierarchyData['user']['DepartmentId'];
      setUserDepartmentId(DepartmentId);
      const EquipmentList = await getHierarchyTreeData(
        permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
      );

      const roleId = JSON.parse(localStorage.get('roleId'));
      let selectedRolesList = await getRolesPermissionsList(roleId);

      let RolesData = selectedRolesList &&
        selectedRolesList.RolesAndPermissions &&
        selectedRolesList.RolesAndPermissions[0] &&
        selectedRolesList.RolesAndPermissions[0].permissions;
      setSelectedRolesList(RolesData);

      if (RolesData && RolesData[0] && RolesData[0].key === 'Failure Reporting And Assignment(user)') {
        let data1 = await getList(RolesData && RolesData[0] && RolesData[0].value);
        setDataSource(data1);
      } else if (RolesData && RolesData[0] && RolesData[0].key === 'Analysis and Corrective Actions') {
        let data2 = await getAnalysisList(RolesData && RolesData[0] && RolesData[0].key);
        setDataSourceForAnalysis(data2);
      }
      if (RolesData && RolesData[0] && RolesData[0].key === 'Failure Reporting And Assignment(manager)') {
        let dataSource = await getHistoryList(DepartmentId, RolesData && RolesData[0] && RolesData[0].value);
        setDataSourceForManager(dataSource);
      }
      let activeKey = RolesData && RolesData[0] && RolesData[0].key;
      // selectedRolesList &&
      //   selectedRolesList.RolesAndPermissions &&
      //   selectedRolesList.RolesAndPermissions[0] &&
      //   selectedRolesList.RolesAndPermissions[0].permissions &&
      //   selectedRolesList.RolesAndPermissions[0].permissions[0];
      setSelectedTabObj(RolesData && RolesData[0]);
      setParentPresentActiveKey(activeKey);
      setEquipmentList(EquipmentList);
      // setDataSource(data);
      let FailureTypeList = await getFailureList();
      setFailureTypeList(FailureTypeList);
      let SeverityList = await getSeverityList();
      setSeverityList(SeverityList);
      let departmentList = await getDepartmentList();
      setDepartmentList(departmentList);
      let userList = await getUserList();
      setUserList(userList);
    };
    fetchData();
  }, []);

  const getList = async (activeTab) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.ReportingGet}?SiteId=${siteId}&ScreenName=${activeTab}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const getAnalysisList = async (activeTab) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.GetAnalysisList}?SiteId=${siteId}&ScreenName=${activeTab}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getHistoryList = async (department, screen) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.GetByDepartmentId}?SiteId=${siteId}&DepartmentId=${department}&ScreenName=${screen}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getFailureList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.FailureTypesGet}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getFailureCodeList = async (checkedValue) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.GetParmsByDevice}?SiteId=${siteId}&Device=${checkedValue}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getSeverityList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.SeverityGet}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const getById = async (Id, screen) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.ReportingGet}?Id=${Id}&SiteId=${siteId}&ScreenName=${screen}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getAnalysisById = async (Id, screen) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.AnalysisGet}?ReportId=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getCorrectiveById = async (Id) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.CorrectiveActionGet}?ReportId=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getDepartmentList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.DepartmentGet}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const getUsersList = async (Id) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.GetUsersByDepartmentId}?DepartmentId=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getUserList = async () => {
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const siteId = localStorage.get('currentSite');
    let data = {
      url: `${API_FRACAS.UserGet}?SiteId=${siteId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    };
    return axios(data)
      .then((response) => {
        return response.data;
      })

      .catch(() => { });
  };
  const getQuestionsList = async (FailureType, selectedEquip) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'POST',
      url: `${API_FRACAS.GetQuestions}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Device: selectedEquip,
        failureTypeId: FailureType
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getRolesPermissionsList = async (RoleId) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'POST',
      url: `${API_FRACAS.PermissionGetById}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { RoleId }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getStatusList = async (status) => {
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const siteId = localStorage.get('currentSite');
    let data = {
      url: `${API_FRACAS.StatusDropdown}?SiteId=${siteId}&Status=${status}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    };
    return axios(data)
      .then((response) => {
        return response.data;
      })

      .catch(() => { });
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setSearchText(prev => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || ''
    }));
  };
  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    confirm();
    setSearchedColumn('');
    setSearchText(prev => ({
      ...prev,
      [dataIndex]: ''
    }));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm')] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm, dataIndex)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={searchText[dataIndex] ? [searchText[dataIndex]] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });

  const getColumnSearchPropsFailureAnalysis = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm')] : [])
            }
            onPressEnter={() => handleSearchFailureAnalysis(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={failureInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearchFailureAnalysis(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearchFailureAnalysis(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleResetFailureAnalysis(clearFilters, confirm, dataIndex)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={failureText[dataIndex] ? [failureText[dataIndex]] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });

  const handleSearchFailureAnalysis = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setFailureText(prev => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || ''
    }));
  };
  const handleResetFailureAnalysis = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    setSearchedColumn('');
    confirm();
    setFailureText(prev => ({
      ...prev,
      [dataIndex]: ''
    }));
  };

  const getColumnSearchPropsFailureAnalysisForManager = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm')] : [])
            }
            onPressEnter={() => handleSearchFailureAnalysisForManager(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={failureAnalysisInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearchFailureAnalysisForManager(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearchFailureAnalysisForManager(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleResetFailureAnalysisForManager(clearFilters, confirm, dataIndex)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={failureAnalysisText[dataIndex] ? [failureAnalysisText[dataIndex]] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });

  const handleSearchFailureAnalysisForManager = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setFailureAnalysisText(prev => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || ''
    }));
  };
  const handleResetFailureAnalysisForManager = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    setSearchedColumn('');
    confirm();
    setFailureAnalysisText(prev => ({
      ...prev,
      [dataIndex]: ''
    }));
  };



  const onModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue(null);
    }

    setTreeVisible(false);
  };
  const onQuestionModalCancel = () => {
    setQuestionVisible(false);
    if (questionsData && questionsData.length !== 0) {
      QuestionRef?.setFieldsValue({
        Questions: questionsData
      });
    } else {
      QuestionRef?.setFieldsValue({
        Questions: []
      });
      setQuestionsData([]);
    }
  };
  const onQuestionModalsOk = () => {
    setQuestionVisible(false);
    let data = QuestionRef?.getFieldsValue();
    setQuestionsData(data.Questions);
    // QuestionRef.current && QuestionRef.current.setFieldsValue({
    //   Questions: []
    // })
  };
  const hierarchyDropdownChange = async (value) => {
    setCheckedValue(value);
    let FailureCodeList = await getFailureCodeList(value);
    setFailureCodeList(FailureCodeList);
    setSelectedDevice(value);
    setFailureTypeId(null);
    setQuestionsList([]);
    setTreeVisible(false);
    form1?.setFieldsValue({
      Device: value,
      FailureTypeId: null,
      FaultCode: null
    });
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    setQuestions([]);
    setQuestionsData([]);
  };

  const onCancel = () => {
    ResetFields();
    analysisFormResetFields();
    correctiveResetFields();
    setCorrectiveStatus(null);
    setCorrectiveButton(false);
    setPresentActiveKey('List');
    setCheckedValue(null);
  };
  const onCorrectiveActionClick = async () => {
    setCorrectiveStatus('Analysis Completed');
    setCorrectiveButton(false);
    let payload = {
      ReportId: formObject && formObject.ReportId,
      Status: status
    };

    let response = await onReportManagerAction(payload);
    if (response && response.status && response.status === 200) {
      const editedRow = await getAnalysisById(formObject.ReportId, 'Analysis and Corrective Actions');
      const analysisList = await getAnalysisList(selectedTabObj && selectedTabObj.key);
      setDataSourceForAnalysis(analysisList);
      let StatusList = await getStatusList(editedRow.FracasStatus);
      setStatusList(StatusList);
    }
  };
  const analysisFormResetFields = async () => {
    form3.resetFields();
    let obj = {
      Id: null,
      AnalysisStartDate: null,
      AnalysisDueDate: null,
      ChangeRecommendations: null,
      FailureCause: null,
      ContributingFactors: null,
      AnalysisComments: null,
      AnalysisAttachments: []
    };
    setAnalysisFormObject(obj);
  };
  const ResetFields = async () => {
    form1?.resetFields();
    form1?.setFieldsValue({
      ReportedDate: dayjs(),
      ReportedBy: props?.userProfile?.user?.FirstName,
      Status: "Open",
      // ...other defaults
    });

    let formData = {
      Device: null,
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: "Open",
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    setQuestions([]);
    setQuestionsData([]);
    setFormObject(formData);
    setSelectedDevice(null);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    setFailureCodeList([]);
    setUsersList([]);
    setStatus("Open");
  };
  const reportingResetFields = () => {
    form1?.setFieldsValue({
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      OccuranceCount: null,
      Remarks: null,
      ReportedDate: dayjs(),
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      UserId: null,
      DepartmentId: null
    });
    let formData = {
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: moment(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    setQuestions([]);
    setQuestionsData([]);
    setRoleId(null);
    setFormObject(formData);
    setSelectedDevice(null);
  };
  const analysisResetFields = () => {
    form2?.setFieldsValue({
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      OccuranceCount: null,
      Remarks: null,
      ReportedDate: dayjs(),
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      UserId: null,
      DepartmentId: null
    });
    let formData = {
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    setQuestions([]);
    setQuestionsData([]);
    setFormObject(formData);
    setSelectedDevice(null);
  };
  const correctiveResetFields = () => {
    form4?.setFieldsValue({
      ChangeRecommendations: null,
      CorrectiveActionType: null,
      CorrectiveActionsAttachments: [],
      ImplementedCorrectiveActions: null,
      PlannedCorrectiveActions: null,
      VerificationAndValidationFieldRemarks: null
    });
    let formData = {
      // ...formObject,
      ChangeRecommendations: null,
      CorrectiveActionType: null,
      CorrectiveActionsAttachments: [],
      ImplementedCorrectiveActions: null,
      PlannedCorrectiveActions: null,
      VerificationAndValidationFieldRemarks: null,

    };
    setCorrectiveFormObject(formData);
    setCorrectiveButton(false);
    setCorrectiveStatus(null);
  };
  const onChangeDepartment = async (value) => {
    let userList = await getUsersList(value);
    setUsersList(userList);
  };
  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setShowusecasedownloadModal(true);
    }
  };
  const analysisHandleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef1.current && myRef1.current.click();
    } else {
      setAnalysisShowusecasedownloadModal(true);
    }
  };
  const correctiveHandleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef2.current && myRef2.current.click();
    } else {
      setCorrectiveShowusecasedownloadModal(true);
    }
  };
  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        filename: file.name
      });
    };
  };
  const fileUpload = (info, key, index) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject) {
        if (formObject['Attachments']) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];

          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'] = [];
          formObject['Attachments'].push({ Id: id, file: Name });
        }
      } else {
        if (formObject && formObject['Attachments'] && formObject['Attachments'].length !== 0) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject &&
            formObject['Attachments'] &&
            formObject['Attachments'].push({ Id: id, file: Name });
        }
      }

      setFormObject(formObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const correctiveFileUpload = (info, key, index) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (correctiveFormObject) {
        if (correctiveFormObject['CorrectiveActionsAttachments']) {
          correctiveFormObject['CorrectiveActionsAttachments'] =
            correctiveFormObject && correctiveFormObject['CorrectiveActionsAttachments'] ? correctiveFormObject['CorrectiveActionsAttachments'] : [];

          correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        } else {
          correctiveFormObject['CorrectiveActionsAttachments'] = [];
          correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        }
      } else {
        if (correctiveFormObject && correctiveFormObject['CorrectiveActionsAttachments'] && correctiveFormObject['CorrectiveActionsAttachments'].length !== 0) {
          correctiveFormObject['CorrectiveActionsAttachments'] =
            correctiveFormObject && correctiveFormObject['CorrectiveActionsAttachments'] ? correctiveFormObject['CorrectiveActionsAttachments'] : [];
          correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        } else {
          correctiveFormObject &&
            correctiveFormObject['CorrectiveActionsAttachments'] &&
            correctiveFormObject['CorrectiveActionsAttachments'].push({ Id: id, file: Name });
        }
      }

      setCorrectiveFormObject(correctiveFormObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const analysisFileUpload = (info, key, index) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (analysisFormObject) {
        if (analysisFormObject['AnalysisAttachments']) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];

          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject['AnalysisAttachments'] = [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      } else {
        if (analysisFormObject && analysisFormObject['AnalysisAttachments'] && analysisFormObject['AnalysisAttachments'].length !== 0) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject &&
            analysisFormObject['AnalysisAttachments'] &&
            analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      }

      setAnalysisFormObject(analysisFormObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const disabledEndDate = (current) => {
    const startDate = form3?.getFieldValue?.('AnalysisStartDate');
    if (!startDate) {
      // If no start date selected, allow all dates
      return false;
    }
    // Disable dates before the selected start date
    return current && current.isBefore(dayjs(startDate), 'day');
  };

  const onStatusChange = (value) => {
    setStatus(value);
    if (value === 'Analysis Completed') {
      setCorrectiveButton(true);
    } else {
      setCorrectiveButton(false);
    }
  };

  const onFinishFailed = () => {
    message.error("Please add mandatory fields");
  };
  const onAnalysisFinishFailed = () => {
    message.error("Please add mandatory fields");
  };
  const onCorrectiveFinishFailed = () => {
    message.error("Please add mandatory fields in Corrective Actions");
  };
  const onReportFormSubmit = async () => {
    let data = QuestionRef?.getFieldsValue();
    QuestionRef?.validateFields();
    let questionsValid = null;
    if (data && data.Questions && Array.isArray(data.Questions)) {
      questionsValid = !data.Questions.some(que => {
        return que === undefined || Object.values(que).length === 1;
      });
    }


    setQuestionsData(data.Questions);
    form1?.validateFields()
      .then(async (values) => {
        values = {
          ...values,
          OccuranceDate: dayjs(values.OccuranceDate).format('YYYY-MM-DD HH:mm'),
          ReportedDate: dayjs(values.ReportedDate).format('YYYY-MM-DD HH:mm'),
          Device: selectedDevice,
          Attachments: formObject.Attachments,
          Questions: data.Questions
        };

        if (values.Id && values.Id !== null) {
          let payload = {};
          if (values.Status !== 'Assigned') {
            payload = {
              ...values
            };

            if (questionsValid !== false) {
              let response = await updateReport(payload);
              if (response && response.status && response.status === 200) {
                message.success(response.data && response.data.message);
                ResetFields();
                setPresentActiveKey('List');
                let data = await getList(selectedTabObj && selectedTabObj.value);
                setDataSource(data);
                // setSelectedDevice(null)
              } 
            } else if (questionsValid === false) {
              message.warning("Please add Questions");
            }
          } else {
            payload = {
              ReportId: values.Id,
              UserId: values.UserId,
              DepartmentId: values.DepartmentId,
              User_Role: `${values.UserId}_${RoleId}`,
              Status: values.Status
            };
            if (questionsValid !== false) {
              let response = await createAssign(payload);
              payload = {
                ...values
              };


              if (response && response.status && response.status === 200) {
                let updateResponse = await updateReport(payload);
                console.log(updateResponse);
                message.success(response.data && response.data.message);
                ResetFields();
                setPresentActiveKey('List');
                let data = await getList(selectedTabObj && selectedTabObj.value);
                setDataSource(data);
                // setSelectedDevice(null)
              }
              //  else {
              //   message.warning('Error while Update');
              // }
            } else if (questionsValid === false) {
              message.warning("Please add Questions");
            }
          }
        } else {
          if (questionsValid !== false) {
            let response = await submitReport(values);
            if (response && response.status && response.status === 200) {
              message.success(response.data && response.data.message);
              ResetFields();
              setPresentActiveKey('List');
              let data = await getList(selectedTabObj && selectedTabObj.value);
              setDataSource(data);
              // setSelectedDevice(null)
            } 
          } else if (questionsValid === false) {
            message.warning("Please add Questions");
          }
        }
      })
      .catch((error) => {
        message.warning(error);
      });
  };
  const onAnalysisFormSubmit = async () => {
    try {
      // Validate main form first and get its values
      await form2?.validateFields();
      const data = form2?.getFieldsValue();

      // If corrective action is required
      if (status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
        || status === 'Verification InProgress' || status === 'Verification completed' ||
        status === 'Closed'
      ) {
        try {
          const values = await form4?.validateFields();
          const payload = {
            ...values,
            CorrectiveActionsAttachments: correctiveFormObject.CorrectiveActionsAttachments,
            Status: data.Status,
            ReportId: data.Id,
          };
          if (values && values.Id && values.Id !== null && values.Id !== undefined) {
            let payload1 = {
              ReportId: formObject && formObject.ReportId,
              Status: status
            };

            let response = await updateCorrectiveActions(payload);
            if (response?.status === 200) {
              let response1 = await onReportManagerAction(payload1);
              console.log(response1);
              message.success(response.data?.message);
              analysisResetFields();
              correctiveResetFields();
              setPresentActiveKey('List');
              const analysisList = await getAnalysisList(selectedTabObj && selectedTabObj.key);
              setDataSourceForAnalysis(analysisList);
            }
          } else {
            const response = await createCorrectiveActions(payload);
            if (response?.status === 200) {
              message.success(response.data?.message);
              analysisResetFields();
              correctiveResetFields();
              setPresentActiveKey('List');
              const analysisList = await getAnalysisList(selectedTabObj && selectedTabObj.key);
              setDataSourceForAnalysis(analysisList);
            }
          }

        } catch (error) {
          console.error(error);
          message.error('Please fill all mandatory corrective action fields.');
        }
        return; // Early return to avoid further execution
      } else if (status === 'Analysis Completed') {
        message.warning("Please change the status");
      } else {
        // Otherwise, handle analysis form
        try {
          const values = await form3?.validateFields();
          const formattedValues = {
            ...values,
            AnalysisStartDate: dayjs(values.AnalysisStartDate).format('YYYY-MM-DD HH:mm'),
            AnalysisDueDate: dayjs(values.AnalysisDueDate).format('YYYY-MM-DD HH:mm'),
            AnalysisAttachments: analysisFormObject.AnalysisAttachments,
          };

          let payload = {};
          // Create
          if (!formattedValues.Id) {
            payload = {
              ...formattedValues,
              ReportId: data.Id,
              Status: data.Status,
            };
            const response = await createFailure(payload);

            if (response?.status === 200) {
              message.success(response.data?.message);

              if (response.data?.Status === 'Analysis Completed') {
                setCorrectiveButton(true);
                const [userList, StatusList, editedRow] = await Promise.all([
                  getUserList(),
                  getStatusList(data.Status),
                  getAnalysisById(data.Id, 'Analysis and Corrective Actions'),
                ]);
                setUserList(userList);
                setStatusList(StatusList);

                if (!editedRow) {
                  console.error('No record found');
                  return;
                }

                const FailureCodeList = await getFailureCodeList(editedRow.Device);
                setFailureCodeList(FailureCodeList);

                if (editedRow.DepartmentId) {
                  const usersList = await getUsersList(editedRow.DepartmentId);
                  setUsersList(usersList);
                }

                form2?.setFieldsValue({
                  Id: editedRow.ReportId,
                  Device: editedRow.Device,
                  FailureTypeId: editedRow.FailureTypeId,
                  FaultCode: editedRow.FaultCode,
                  Impact: editedRow.Impact,
                  OccuranceCount: editedRow.OccuranceCount,
                  Remarks: editedRow.Remarks,
                  SeverityId: editedRow.SeverityId,
                  OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
                  ReportedDate: dayjs(editedRow.ReportedDate),
                  FailureDescription: editedRow.FailureDescription,
                  ReportedBy: editedRow.ReportedName,
                  Comments: editedRow.Comments,
                  Status: editedRow.FracasStatus,
                  DepartmentId: editedRow.DepartmentId,
                  UserId: editedRow.UserId_RoleId,
                });

                form3.setFieldsValue({
                  Id: editedRow.Id,
                  AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
                  AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
                  ChangeRecommendations: editedRow.ChangeRecommendations,
                  FailureCause: editedRow.FailureCause,
                  ContributingFactors: editedRow.ContributingFactors,
                  AnalysisComments: editedRow.AnalysisComments,
                  AnalysisAttachments: editedRow.AnalysisAttachments,
                });

                setAnalysisFormObject({
                  Id: editedRow.Id,
                  AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
                  AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
                  ChangeRecommendations: editedRow.ChangeRecommendations,
                  FailureCause: editedRow.FailureCause,
                  ContributingFactors: editedRow.ContributingFactors,
                  AnalysisComments: editedRow.AnalysisComments,
                  AnalysisAttachments: editedRow.AnalysisAttachments,
                });

                setFailureTypeId(editedRow.FailureTypeId);
                setFormObject({
                  Id: editedRow.ReportId,
                  Device: editedRow.Device,
                  FailureTypeId: editedRow.FailureTypeId,
                  FaultCode: editedRow.FaultCode,
                  Impact: editedRow.Impact,
                  OccuranceCount: editedRow.OccuranceCount,
                  Remarks: editedRow.Remarks,
                  SeverityId: editedRow.SeverityId,
                  OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
                  ReportedDate: dayjs(editedRow.ReportedDate),
                  FailureDescription: editedRow.FailureDescription,
                  ReportedBy: editedRow.ReportedName,
                  Attachments: editedRow.Attachments,
                  Comments: editedRow.Comments,
                  Status: editedRow.FracasStatus,
                  Questions: editedRow.Questions,
                  DepartmentId: editedRow.DepartmentId,
                  UserId: editedRow.UserId_RoleId,
                });
                setSelectedDevice(editedRow.Device);

                const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
                setQuestionsList(questionsList);
                QuestionRef?.setFieldsValue({ Questions: editedRow.Questions });
                setQuestions(editedRow.Questions);
              } else {
                analysisResetFields();
                setPresentActiveKey('List');
                const analysisList = await getAnalysisList(selectedTabObj && selectedTabObj.key);
                setDataSourceForAnalysis(analysisList);
              }
            } else {
              setCorrectiveStatus(null);
              // message.warning('Error while creating analysis');
            }
          } else {
            // Update
            payload = {
              ...formattedValues,
              ReportId: data.Id,
              Id: formattedValues.Id,
              Status: data.Status,
            };
            const response = await updateFailure(payload);

            if (response?.status === 200) {
              message.success(response.data?.message);
              analysisResetFields();
              setPresentActiveKey('List');
              const analysisList = await getAnalysisList(selectedTabObj && selectedTabObj.key);
              setDataSourceForAnalysis(analysisList);
            } else {
              message.warning('Error while updating analysis');
            }
          }
        } catch (error) {
          message.error('Please add mandatory fields in analysis form');
        }
      }


    } catch (error) {
      message.error('Please fill all mandatory fields in the main form');
    }
  };
  const onManagerFormSubmit = async () => {
    let payload = {
      ReportId: formObject && formObject.ReportId,
      Status: status
    };
    const values = await form_Manager3?.validateFields();
    const payload1 = {
      ...values,
      CorrectiveActionsAttachments: correctiveFormObject.CorrectiveActionsAttachments,
      Status: status,
      ReportId: formObject && formObject.ReportId,
    };
    let response = await onReportManagerAction(payload);
    if (response && response.status && response.status === 200) {
      message.success(response.data && response.data.message);

      if (status === 'Verification InProgress' || status === 'Verification completed'
        || status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented') {

        let response1 = await updateCorrectiveActions(payload1);
        if (response1?.status === 200) {
          // message.success(response1.data?.message);
          ResetFields();
          analysisResetFields();
          correctiveResetFields();
          setPresentActiveKey('List');
          let data = await getHistoryList(userDepartmentId, selectedTabObj && selectedTabObj.value);
          setDataSourceForManager(data);


        } else {
          message.error('Error while updating the Corrective Actions');
        }
        ResetFields();
        analysisResetFields();
        correctiveResetFields();
        setPresentActiveKey('List');
        let data = await getHistoryList(userDepartmentId, selectedTabObj && selectedTabObj.value);
        setDataSourceForManager(data);


      } else {
        ResetFields();
        analysisResetFields();
        correctiveResetFields();
        setPresentActiveKey('List');
        let data = await getHistoryList(userDepartmentId, selectedTabObj && selectedTabObj.value);
        setDataSourceForManager(data);
      }


    }
    else {
      message.warning('Error while create');
    }
  };
  const onQuestionChange = (value, rowIndex) => {
    const questions = (QuestionRef?.getFieldValue('Questions')) || [];
    questions[rowIndex] = {
      ...questions[rowIndex],
      Answers: '', // Reset answer
      QuestionId: value
    };
    QuestionRef?.setFieldsValue({ Questions: questions });
  };
  const addNew = (key) => {
    setSelectedKey('new');
    setPresentActiveKey('Details');
    ResetFields();
  };

  dayjs.extend(utc);


  const editRecord = async (record, key) => {
    setPresentActiveKey('Details');
    setSelectedKey(key);
    let userList = await getUserList();
    setUserList(userList);
    let StatusList = await getStatusList(record.Status);
    setStatusList(StatusList);
    try {
      const editedRow = await getById(record.Id, 'Failure Reporting And Assignment');

      if (!editedRow || !editedRow[0]) {
        console.error('No record found');
        return;
      }
      let departmentList = await getDepartmentList();
      setDepartmentList(departmentList);
      if (editedRow && editedRow[0].DepartmentId) {
        let userList = await getUsersList(editedRow && editedRow[0].DepartmentId);
        setUsersList(userList);
      }
      let FailureCodeList = await getFailureCodeList(editedRow[0].Device);
      setFailureCodeList(FailureCodeList);
      // const questionsList = await getQuestionsList(editedRow[0].FailureTypeId);
      // setQuestionsList(questionsList);
      form1?.setFieldsValue({
        Id: editedRow[0].Id,
        Device: editedRow[0].Device,
        FailureTypeId: editedRow[0].FailureTypeId,
        FaultCode: editedRow[0].FaultCode,
        Impact: editedRow[0].Impact,
        OccuranceCount: editedRow[0].OccuranceCount,
        Remarks: editedRow[0].Remarks,
        SeverityId: editedRow[0].SeverityId,
        OccuranceDate: dayjs(editedRow[0].OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow[0].ReportedDate),
        FailureDescription: editedRow[0].FailureDescription,
        ReportedBy: editedRow[0].ReportedName,
        Comments: editedRow && editedRow[0] && editedRow[0].Comments,
        Status: editedRow && editedRow[0] && editedRow[0].Status,
        DepartmentId: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        UserId: editedRow && editedRow[0] && editedRow[0].UserId_RoleId
      });

      const updatedForm = {
        Id: editedRow[0].Id,
        Device: editedRow[0].Device,
        FailureTypeId: editedRow[0].FailureTypeId,
        FaultCode: editedRow[0].FaultCode,
        Impact: editedRow[0].Impact,
        OccuranceCount: editedRow[0].OccuranceCount,
        Remarks: editedRow[0].Remarks,
        SeverityId: editedRow[0].SeverityId,
        OccuranceDate: dayjs(editedRow[0].OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow[0].ReportedDate),
        FailureDescription: editedRow[0].FailureDescription,
        ReportedBy: editedRow[0].ReportedName,
        Attachments: editedRow[0].Attachments,
        Comments: editedRow && editedRow[0] && editedRow[0].Comments,
        Status: editedRow && editedRow[0] && editedRow[0].Status,
        Questions: editedRow && editedRow[0] && editedRow[0].Questions,
        DepartmentId: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        UserId: editedRow && editedRow[0] && editedRow[0].UserId_RoleId,
        Department: editedRow && editedRow[0] && editedRow[0].DepartmentId,
        User: editedRow && editedRow[0] && editedRow[0].UserId
      };
      setFailureTypeId(editedRow[0].FailureTypeId);
      setFormObject(updatedForm);
      setSelectedDevice(editedRow[0].Device);
      setStatus(editedRow[0].Status);
      const questionsList = await getQuestionsList(editedRow[0].FailureTypeId, editedRow[0].Device);
      setQuestionsList(questionsList);
      QuestionRef?.setFieldsValue({
        Questions: editedRow[0].Questions
      });
      setQuestions(editedRow[0].Questions);
    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const AnalysisEdit = async (record, key) => {
    setPresentActiveKey('Details');
    setSelectedKey(key);

    try {
      // Fetch user and status lists
      const userList = await getUserList();
      setUserList(userList);

      const statusList = await getStatusList(record.Status);
      setStatusList(statusList);

      // Fetch analysis and corrective data
      const editedRow = await getAnalysisById(record.Id, 'Analysis and Corrective Actions');
      const correctiveEdit = await getCorrectiveById(record.Id);

      // Handle Corrective Edit
      if (correctiveEdit && correctiveEdit[0] && correctiveEdit[0].Id) {
        const correctiveData = correctiveEdit[0];
        await form4?.setFieldsValue({
          // ...correctiveData
          Id: correctiveData.Id,
          ChangeRecommendations: correctiveData.ChangeRecommendations,
          CorrectiveActionType: correctiveData.CorrectiveActionType,
          // CorrectiveActionsAttachments: correctiveData.CorrectiveActionsAttachments,
          ImplementedCorrectiveActions: correctiveData.ImplementedCorrectiveActions,
          PlannedCorrectiveActions: correctiveData.PlannedCorrectiveActions,
          VerificationAndValidationFieldRemarks: correctiveData.VerificationAndValidationFieldRemarks
        });

        setCorrectiveFormObject({
          // ...correctiveData
          Id: correctiveData.Id,
          ChangeRecommendations: correctiveData.ChangeRecommendations,
          CorrectiveActionType: correctiveData.CorrectiveActionType,
          CorrectiveActionsAttachments: correctiveData.CorrectiveActionsAttachments,
          ImplementedCorrectiveActions: correctiveData.ImplementedCorrectiveActions,
          PlannedCorrectiveActions: correctiveData.PlannedCorrectiveActions,
          VerificationAndValidationFieldRemarks: correctiveData.VerificationAndValidationFieldRemarks
        });

        setCorrectiveButton(false);
        setCorrectiveStatus('Analysis Completed');
      } else {
        await form4?.setFieldsValue({
          // ...correctiveData
          Id: null,
          ChangeRecommendations: null,
          CorrectiveActionType: null,
          CorrectiveActionsAttachments: null,
          ImplementedCorrectiveActions: null,
          PlannedCorrectiveActions: null,
          VerificationAndValidationFieldRemarks: null
        });

        setCorrectiveFormObject({
          // ...correctiveData
          Id: null,
          ChangeRecommendations: null,
          CorrectiveActionType: null,
          CorrectiveActionsAttachments: null,
          ImplementedCorrectiveActions: null,
          PlannedCorrectiveActions: null,
          VerificationAndValidationFieldRemarks: null
        });

        setCorrectiveButton(false);
        setCorrectiveStatus(null);
      }

      // If analysis record not found
      if (!editedRow) {
        console.error('No record found');
        return;
      }

      // Fetch failure code list
      const failureCodeList = await getFailureCodeList(editedRow.Device);
      setFailureCodeList(failureCodeList);

      // Fetch users list based on department
      if (editedRow.DepartmentId) {
        const departmentUsers = await getUsersList(editedRow.DepartmentId);
        setUsersList(departmentUsers);
      }

      // Set main form fields
      await form2?.setFieldsValue({
        ...editedRow,
        Id: editedRow.ReportId,
        Device: editedRow.Device,
        FailureTypeId: editedRow.FailureTypeId,
        FaultCode: editedRow.FaultCode,
        Impact: editedRow.Impact,
        OccuranceCount: editedRow.OccuranceCount,
        Remarks: editedRow.Remarks,
        SeverityId: editedRow.SeverityId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        FailureDescription: editedRow.FailureDescription,
        ReportedBy: editedRow.ReportedName,
        Comments: editedRow.Comments,
        Status: editedRow.FracasStatus,
        DepartmentId: editedRow.DepartmentId,
        UserId: editedRow.UserId_RoleId,
        Attachments: editedRow.Attachments
      });

      setFormObject({
        ...editedRow,
        Id: editedRow.ReportId,
        Device: editedRow.Device,
        FailureTypeId: editedRow.FailureTypeId,
        FaultCode: editedRow.FaultCode,
        Impact: editedRow.Impact,
        OccuranceCount: editedRow.OccuranceCount,
        Remarks: editedRow.Remarks,
        SeverityId: editedRow.SeverityId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        FailureDescription: editedRow.FailureDescription,
        ReportedBy: editedRow.ReportedName,
        Comments: editedRow.Comments,
        Status: editedRow.FracasStatus,
        DepartmentId: editedRow.DepartmentId,
        UserId: editedRow.UserId_RoleId,
        Attachments: editedRow.Attachments
      });

      if (editedRow.Id) {
        await form3?.setFieldsValue({
          // ...editedRow,
          Id: editedRow.Id,
          AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
          FailureCause: editedRow.FailureCause,
          ContributingFactors: editedRow.ContributingFactors,
          AnalysisComments: editedRow.AnalysisComments,
          AnalysisAttachments: editedRow.AnalysisAttachments
        });

        setAnalysisFormObject({
          // ...editedRow,
          Id: editedRow.Id,
          AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
          ChangeRecommendations: editedRow.ChangeRecommendations,
          FailureCause: editedRow.FailureCause,
          ContributingFactors: editedRow.ContributingFactors,
          AnalysisComments: editedRow.AnalysisComments,
          AnalysisAttachments: editedRow.AnalysisAttachments
        });
      } else {
        await form3?.setFieldsValue({
          Id: null,
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });

        setAnalysisFormObject({
          Id: null,
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });
      }
      if (editedRow && editedRow.FracasStatus && editedRow.FracasStatus === 'Analysis Completed') {
        setCorrectiveButton(true);
      }
      setStatus(editedRow.FracasStatus);
      setFailureTypeId(editedRow.FailureTypeId);
      setSelectedDevice(editedRow.Device);

      // Fetch and set questions
      const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
      setQuestionsList(questionsList);

      await QuestionRef?.setFieldsValue({
        Questions: editedRow.Questions
      });
      setQuestions(editedRow.Questions);

    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const managerEdit = async (record, key) => {
    setPresentActiveKey('Details');
    setSelectedKey(key);

    try {
      // Fetch user and status lists
      const userList = await getUserList();
      setUserList(userList);

      const statusList = await getStatusList(record.Status);
      setStatusList(statusList);

      // Fetch analysis and corrective data
      const editedRow = await getAnalysisById(record.Id, 'Analysis and Corrective Actions');
      const correctiveEdit = await getCorrectiveById(record.Id);

      // Handle Corrective Edit
      if (correctiveEdit && correctiveEdit[0] && correctiveEdit[0].Id) {
        const correctiveData = correctiveEdit[0];
        await form_Manager3?.setFieldsValue({
          // ...correctiveData
          Id: correctiveData.Id,
          ChangeRecommendations: correctiveData.ChangeRecommendations,
          CorrectiveActionType: correctiveData.CorrectiveActionType,
          // CorrectiveActionsAttachments: correctiveData.CorrectiveActionsAttachments,
          ImplementedCorrectiveActions: correctiveData.ImplementedCorrectiveActions,
          PlannedCorrectiveActions: correctiveData.PlannedCorrectiveActions,
          VerificationAndValidationFieldRemarks: correctiveData.VerificationAndValidationFieldRemarks
        });

        setCorrectiveFormObject({
          // ...correctiveData,
          Id: correctiveData.Id,
          ChangeRecommendations: correctiveData.ChangeRecommendations,
          CorrectiveActionType: correctiveData.CorrectiveActionType,
          CorrectiveActionsAttachments: correctiveData.CorrectiveActionsAttachments,
          ImplementedCorrectiveActions: correctiveData.ImplementedCorrectiveActions,
          PlannedCorrectiveActions: correctiveData.PlannedCorrectiveActions,
          VerificationAndValidationFieldRemarks: correctiveData.VerificationAndValidationFieldRemarks
        });

        setCorrectiveButton(false);
        setCorrectiveStatus('Analysis Completed');
      } else {
        await form_Manager3?.setFieldsValue({
          // ...correctiveData
          Id: null,
          ChangeRecommendations: null,
          CorrectiveActionType: null,
          CorrectiveActionsAttachments: null,
          ImplementedCorrectiveActions: null,
          PlannedCorrectiveActions: null,
          VerificationAndValidationFieldRemarks: null
        });

        setCorrectiveFormObject({
          // ...correctiveData
          Id: null,
          ChangeRecommendations: null,
          CorrectiveActionType: null,
          CorrectiveActionsAttachments: null,
          ImplementedCorrectiveActions: null,
          PlannedCorrectiveActions: null,
          VerificationAndValidationFieldRemarks: null
        });

        setCorrectiveButton(false);
        setCorrectiveStatus(null);
      }

      // If analysis record not found
      if (!editedRow) {
        console.error('No record found');
        return;
      }

      // Fetch failure code list
      const failureCodeList = await getFailureCodeList(editedRow.Device);
      setFailureCodeList(failureCodeList);

      // Fetch users list based on department
      if (editedRow.DepartmentId) {
        const departmentUsers = await getUsersList(editedRow.DepartmentId);
        setUsersList(departmentUsers);
      }

      // Set main form fields
      await form_Manager1?.setFieldsValue({
        ...editedRow,
        Id: editedRow.ReportId,
        Device: editedRow.Device,
        FailureTypeId: editedRow.FailureTypeId,
        FaultCode: editedRow.FaultCode,
        Impact: editedRow.Impact,
        OccuranceCount: editedRow.OccuranceCount,
        Remarks: editedRow.Remarks,
        SeverityId: editedRow.SeverityId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        FailureDescription: editedRow.FailureDescription,
        ReportedBy: editedRow.ReportedName,
        Comments: editedRow.Comments,
        Status: editedRow.FracasStatus,
        DepartmentId: editedRow.DepartmentId,
        UserId: editedRow.UserId_RoleId,
        Attachments: editedRow.Attachments
      });

      setFormObject({
        ...editedRow,
        Id: editedRow.ReportId,
        Device: editedRow.Device,
        FailureTypeId: editedRow.FailureTypeId,
        FaultCode: editedRow.FaultCode,
        Impact: editedRow.Impact,
        OccuranceCount: editedRow.OccuranceCount,
        Remarks: editedRow.Remarks,
        SeverityId: editedRow.SeverityId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        FailureDescription: editedRow.FailureDescription,
        ReportedBy: editedRow.ReportedName,
        Comments: editedRow.Comments,
        Status: editedRow.FracasStatus,
        DepartmentId: editedRow.DepartmentId,
        UserId: editedRow.UserId_RoleId,
        Attachments: editedRow.Attachments
      });

      // Set analysis form fields

      if (editedRow.Id) {

        await form_Manager2?.setFieldsValue({
          // ...editedRow,
          Id: editedRow.Id,
          AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
          FailureCause: editedRow.FailureCause,
          ContributingFactors: editedRow.ContributingFactors,
          AnalysisComments: editedRow.AnalysisComments,
          AnalysisAttachments: editedRow.AnalysisAttachments
        });

        setAnalysisFormObject({
          // ...editedRow,
          Id: editedRow.Id,
          AnalysisStartDate: dayjs(editedRow.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(editedRow.AnalysisDueDate).utc(),
          ChangeRecommendations: editedRow.ChangeRecommendations,
          FailureCause: editedRow.FailureCause,
          ContributingFactors: editedRow.ContributingFactors,
          AnalysisComments: editedRow.AnalysisComments,
          AnalysisAttachments: editedRow.AnalysisAttachments
        });
      } else {
        await form_Manager2?.setFieldsValue({
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });

        setAnalysisFormObject({
          Id: null,
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });
      }

      setFailureTypeId(editedRow.FailureTypeId);
      setSelectedDevice(editedRow.Device);

      // Fetch and set questions
      const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
      setQuestionsList(questionsList);
      setStatus(editedRow.FracasStatus);
      await QuestionRef?.setFieldsValue({
        Questions: editedRow.Questions
      });
      setQuestions(editedRow.Questions);

    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const handleTableChange = (pagination) => {
    setCurrent(pagination.current);
  };

  const fileupload = async (values, key) => {
    // Get the current form values
    let currentFormObject = form1?.getFieldsValue();

    // Check if the key already exists in the form object
    if (currentFormObject[key]) {
      currentFormObject[key].push(...values);
    } else {
      currentFormObject[key] = values;
    }

    // Remove duplicates based on the 'Name' property
    currentFormObject[key] = currentFormObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    // Update the form object
    currentFormObject = {
      ...currentFormObject,
      [key]: currentFormObject[key]
    };

    // Set the updated values back to the form
    form1?.setFieldsValue(currentFormObject);

    // Update the state for formObject and fileData
    setFormObject(currentFormObject);
    // setFileData(values); // Assuming you want to set the new file data
  };
  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };

  const onFailureTypeChange = async (value) => {
    const questionsList = await getQuestionsList(value, selectedDevice);
    setQuestionsList(questionsList);
    setFailureTypeId(value);
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    setQuestionsData([]);
    setQuestions([]);
  };
  // const validateMessages = {
  //   required: translation('${label}') + translation('is required!')
  // };

  const DeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };
  const AnalysisDeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = analysisFormObject && analysisFormObject.AnalysisAttachments && analysisFormObject.AnalysisAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...analysisFormObject,
      AnalysisAttachments: filteredAttachments
    };
    setAnalysisFormObject(data);
  };
  const CorrectiveDeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = correctiveFormObject && correctiveFormObject.CorrectiveActionsAttachments && correctiveFormObject.CorrectiveActionsAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...correctiveFormObject,
      CorrectiveActionsAttachments: filteredAttachments
    };
    setCorrectiveFormObject(data);
  };
  const onAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };
  const onAnalysisAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = analysisFormObject && analysisFormObject.AnalysisAttachments && analysisFormObject.AnalysisAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...analysisFormObject,
      AnalysisAttachments: filteredAttachments
    };
    setAnalysisFormObject(data);
  };
  const onCorrectiveAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = correctiveFormObject && correctiveFormObject.CorrectiveActionsAttachments && correctiveFormObject.CorrectiveActionsAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...correctiveFormObject,
      CorrectiveActionsAttachments: filteredAttachments
    };
    setCorrectiveFormObject(data);
  };
  const formItemLayout = { width: '100%', flex: '50%' };

  const FailureReportColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchProps('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'EquipmentCode',
      key: 'EquipmentCode',
      ...getColumnSearchProps('EquipmentCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchProps('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      key: 'SeverityName',
      ...getColumnSearchProps('SeverityName')
    },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      key: 'DetectionSource',
      ...getColumnSearchProps('DetectionSource')
    },
    {
      title: translation('Occurred Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('OccuranceDate'),
      // render: (text) => (
      //   <div>{dayjs.utc(text, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss')}</div>
      // )
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Created Date'),
      dataIndex: 'ReportedDate',
      key: 'ReportedDate',
      sorter: (a, b) => dayjs(a.ReportedDate) - dayjs(b.ReportedDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('ReportedDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchProps('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          {record.Status === 'On hold' || record.Status === 'Open' || record.Status === 'Reject' ?
            <>
              <Button type="primary" onClick={() => editRecord(record, 'edit')}>
                <Tooltip title={translation('Edit')}>
                  <EditOutlined />
                </Tooltip>
              </Button>
            </>
            :
            <>
              <Button type="primary" onClick={() => editRecord(record, 'view')}>
                <Tooltip title={translation('View')}>
                  <EyeOutlined />
                </Tooltip>
              </Button>
            </>
          }
        </>
      )
    }
  ];
  const FailureAnalysisColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchPropsFailureAnalysis('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'EquipmentCode',
      key: 'EquipmentCode',
      ...getColumnSearchPropsFailureAnalysis('EquipmentCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchPropsFailureAnalysis('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      key: 'SeverityName',
      ...getColumnSearchPropsFailureAnalysis('SeverityName')
    },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      key: 'DetectionSource',
      ...getColumnSearchPropsFailureAnalysis('DetectionSource')
    },
    {
      title: translation('Occurred Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchPropsFailureAnalysis('OccuranceDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchPropsFailureAnalysis('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (

        <>
          {record.Status === 'Closed' || record.Status === 'Verification completed' || record.Status === 'Reject' ?
            <>
              <Button type="primary" onClick={() => AnalysisEdit(record, 'view')}>
                <Tooltip title={translation('View')}>
                  <EyeOutlined />
                </Tooltip>
              </Button>
            </>
            :
            <>
              <Button type="primary" onClick={() => AnalysisEdit(record, 'edit')}>
                <Tooltip title={translation('Edit')}>
                  <EditOutlined />
                </Tooltip>
              </Button>
            </>
          }
        </>
      )
    }
  ];
  const FailureAnalysisForManagerColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchPropsFailureAnalysisForManager('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'EquipmentCode',
      key: 'EquipmentCode',
      ...getColumnSearchPropsFailureAnalysisForManager('EquipmentCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchPropsFailureAnalysisForManager('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      key: 'SeverityName',
      ...getColumnSearchPropsFailureAnalysisForManager('SeverityName')
    },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      key: 'DetectionSource',
      ...getColumnSearchPropsFailureAnalysisForManager('DetectionSource')
    },
    {
      title: translation('Occurred Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchPropsFailureAnalysisForManager('OccuranceDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchPropsFailureAnalysisForManager('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          {record.Status === 'Closed'
            || record.Status === 'Open'
            || record.Status === 'Assigned'
            || record.Status === 'Under Analysis'
            || record.Status === 'Analysis Completed'
            || record.Status === 'Analysis to be reviewed'
            || record.Status === 'Reassign'
            || record.Status === 'Reject'
            || record.Status === 'On hold'
            // || record.Status === 'Reassign'
            // || record.Status === 'Analysis to be reviewed'
            ?
            <>
              <Button type="primary" onClick={() => managerEdit(record, 'view')}>
                <Tooltip title={translation('View')}>
                  <EyeOutlined />
                </Tooltip>
              </Button>
            </>
            :
            <>
              <Button type="primary" onClick={() => managerEdit(record, 'edit')}>
                <Tooltip title={translation('Edit')}>
                  <EditOutlined />
                </Tooltip>
              </Button>
            </>
          }
        </>
      )
    }
  ];
  const UseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '25px' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => DeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}

        </div>
      )
    }
  ];
  const AnalysisUseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (

        <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '25px' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAnalysisAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => AnalysisDeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const CorrectiveActionsUseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '25px' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onCorrectiveAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => CorrectiveDeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const selectedQuestionIds = Form.useWatch('Questions', QuestionRef)?.map(q => q?.QuestionId) || [];
  // const selectedRolesList = ['Reporting', 'Failure Reporting And Assignment'];
  return (
    <StyledHomepage>
      <Tabs
        defaultActiveKey={selectedRolesList && selectedRolesList[0] && selectedRolesList[0].key}
        activeKey={parentPresentActiveKey}
        onChange={async (activeKey) => {
          let data = selectedRolesList && selectedRolesList.filter((role) => role.key === activeKey);

          setSelectedTabObj(data && data[0]);
          if (activeKey && activeKey === "Analysis and Corrective Actions") {
            let data1 = await getAnalysisList(data && data[0] && data[0].key);
            setDataSourceForAnalysis(data1);
          } else if (activeKey === 'Failure Reporting And Assignment(user)') {
            let data2 = await getList(data && data[0] && data[0].value);
            setDataSource(data2);
          }
          if (activeKey && activeKey === "Failure Reporting And Assignment(manager)") {
            let dataSource = await getHistoryList(userDepartmentId, data && data[0] && data[0].value);
            setDataSourceForManager(dataSource);
          }
          setParentPresentActiveKey(activeKey);
          setPresentActiveKey('List');
          ResetFields();
          setCurrent(1);
          correctiveResetFields();
          setCheckedValue(null);
        }}
        type="card"
        className="TabsText"
      >

        {selectedRolesList && Array.isArray(selectedRolesList) && selectedRolesList.map(role => (
          <>
            <TabPane tab={translation(role.value)} key={role.key}>
              {role && role.key === "Failure Reporting And Assignment(user)" && (
                <Tabs
                  defaultActiveKey="List"
                  activeKey={presentActiveKey}
                // onChange={(activeKey) => {
                //   // setPresentActiveKey('List');
                //   reportingResetFields();
                //   setCheckedValue(null);
                // }}
                >
                  <TabPane tab={'List'} key="List">
                    <Button
                      type="primary"
                      onClick={addNew}
                      style={{
                        background: '#214972',
                        marginBottom: '10px',
                        float: 'right',
                        marginTop: '5px'
                      }}
                    >
                      <PlusOutlined /> Add
                    </Button>
                    <StyledTable size="small"
                      columns={FailureReportColumns}
                      dataSource={dataSource}
                      style={{ marginTop: '24px' }}
                      pagination={{
                        current,
                        onChange: (page) => setCurrent(page),
                      }}
                      onChange={handleTableChange}
                    />
                  </TabPane>
                  <TabPane tab={'Details'} key="Details">
                    <div style={{ padding: '10px 19px' }}>
                      <div style={{ color: 'white', cursor: 'pointer' }}>
                        <Button type='primary' style={{ cursor: 'pointer' }}
                          onClick={() => {
                            ResetFields();
                            setPresentActiveKey('List');
                          }}
                        >
                          <RollbackOutlined />
                          {translation('Go Back')}
                        </Button>
                      </div>
                    </div>
                    <Form
                      name="FailureReport"
                      ref={h1Ref}
                      form={form1}
                      autoComplete="off"
                      initialValues={formObject}
                      layout="vertical"
                      onFinish={onReportFormSubmit}
                      onFinishFailed={onFinishFailed}
                      labelWrap
                      style={{ paddingLeft: '5%' }}
                    >
                      {/* <div 
                      // style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px', paddingLeft: '4%' }}
                      > */}
                      <Row gutter={16}>
                        <Form.Item name="Id"></Form.Item>
                        <Col span={8}>
                          <Form.Item
                            name="Device"
                            label={translation(`Equipment`)}
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Equipment!"),
                              },
                            ]}
                            style={formItemLayout}
                          >
                            <div style={{ display: 'flex', gap: '1%', flexWrap: 'wrap', width: '100%' }}>
                                <Select
                                  style={{
                                    width: '60%'
                                  }}
                                  value={selectedDevice}
                                  // mode="multiple"
                                  placeholder={translation('Select Equipment')}

                                  disabled={true}
                                >
                                  {devicesList &&
                                    Array.isArray(devicesList) &&
                                    devicesList.map((eqp, index) => {
                                      return (
                                        <Option key={index} value={eqp.AliasCode}>
                                          {`${eqp.DisplayCode}`}
                                        </Option>
                                      );
                                    })}
                                </Select>
                                <Button
                                  type="primary"
                                  style={{width:'9%'}}
                                  onClick={() => {
                                    setTreeVisible(true);
                                  }}
                                  disabled={formObject.Id}
                                >
                                  <UpSquareOutlined />
                                </Button>
                            </div>
                          </Form.Item>
                        </Col>

                        <Col span={8}>

                          <Form.Item
                            label={translation('Failure Type')}
                            name='FailureTypeId'
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Failure Type!"),
                              },
                            ]}
                            style={formItemLayout}
                          >
                            <Select
                              disabled={((formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject')) && selectedDevice ? false : true}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Failure Type')}

                              onChange={onFailureTypeChange}
                            >
                              {FailureTypeList &&
                                Array.isArray(FailureTypeList) &&
                                FailureTypeList.map((device, index) => {
                                  return (
                                    <Option key={index} value={device.Id}>
                                      {device.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>

                          <Form.Item
                            label={translation('Fault Code')}
                            name="FaultCode"
                            style={formItemLayout}
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Fault Code!"),
                              },
                            ]}

                          >
                            <Select
                              disabled={formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject' ? false : true}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Fault Code')}
                            >
                              {FailureCodeList &&
                                Array.isArray(FailureCodeList) &&
                                FailureCodeList.map((FailureCode, index) => {
                                  return (
                                    <Option key={index} value={FailureCode.VendorCode}>
                                      {FailureCode.ParameterDescription}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Severity')}
                            name="SeverityId"
                            style={formItemLayout}
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Severity!"),
                              },
                            ]}
                          >
                            <Select
                              disabled={formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject' ? false : true}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Severity')}

                            >
                              {SeverityList &&
                                Array.isArray(SeverityList) &&
                                SeverityList.map((device, index) => {
                                  return (
                                    <Option key={index} value={device.Id}>
                                      {device.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Failure Occurred Date&Time')}
                            name="OccuranceDate"
                            style={formItemLayout}
                            rules={[
                              {
                                required: true,
                                message: translation("Please Select Failure Occurred Date&Time!"),
                              },
                            ]}
                          >
                            <DatePicker
                              disabled={formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject' ? false : true}
                              showTime={{ format: 'HH:mm' }}
                              placeholder="Select Occurance Date"
                              inputReadOnly={true}
                              style={{ width: '70%' }}
                              format="YYYY-MM-DD HH:mm"
                              disabledDate={disabledDate}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            label={translation('Failure Occurrence Count')}
                            name="OccuranceCount"
                            style={formItemLayout}
                            rules={[
                              {
                                required: true,
                                message: translation("Please input Failure Occurrence Count!"),
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              min={0} max={100000}
                              onKeyDown={(e) => {
                                if ([8].includes(e.keyCode)) {
                                  return;
                                }
                                if (
                                  (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                  (e.keyCode < 96 || e.keyCode > 105)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              disabled={formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject' ? false : true}
                              placeholder={translation('Failure Occurrence Count')}
                              style={{ width: '70%' }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Failure Description')}
                            name="FailureDescription"
                            style={formItemLayout}
                          >
                            <TextArea
                              disabled={formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject' ? false : true}
                              placeholder={translation('Failure Description')}
                              style={{ width: '70%' }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Failure Impact')}
                            name="Impact"
                            style={formItemLayout}
                          >
                            <TextArea
                              disabled={formObject.Status === 'Open' || formObject.Status === 'On hold' ||
                                formObject.Status === 'Reject' ? false : true}
                              placeholder={translation('Add Failure Impact')}
                              style={{ width: '70%' }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Comments')}
                            name="Comments"
                            style={formItemLayout}
                          >
                            <TextArea
                              placeholder={translation('Add Comments')}
                              style={{ width: '70%' }}
                              disabled={formObject.Id && (formObject.Status !== 'Open' && formObject.Status !== 'On hold' &&
                                formObject.Status !== 'Reject')
                              }
                            />
                          </Form.Item>
                        </Col>

                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Failure Reported Date')}
                            name="ReportedDate"
                            style={formItemLayout}
                          >
                            <DatePicker
                              format={'YYYY-MM-DD HH:mm'}
                              style={{ width: '70%' }}
                              disabled={true}
                              placeholder={translation('Failure Reported Date')}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                         
                          <Form.Item
                            style={formItemLayout}
                            name="Attachments"
                            label={translation('Attachments')}
                          >
                            <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                  <Button
                                    onClick={() => handleClick('Add New Attachments')}
                                    style={{ width: '34%' }}
                                    disabled={(formObject && formObject.Id) && (formObject.Status !== 'Open' && formObject.Status !== 'On hold' &&
                                      formObject.Status !== 'Reject')}>
                                    <CloudUploadOutlined /> Upload files
                                  </Button>
                                  <Button onClick={() => handleClick('View Attachments')} style={{ width: '34%' }}>
                                    <EyeOutlined /> View files
                                  </Button>
                            </div>
                            <Upload
                              multiple={true}
                              beforeUpload={(file) => {
                                const isCSV =
                                  file.type === 'image/jpeg' ||
                                  file.name.endsWith('.jpg') ||
                                  file.name.endsWith('.jpeg') ||
                                  file.name.endsWith('.pdf') ||
                                  file.name.endsWith('.png') ||
                                  file.name.endsWith('.ppt') ||
                                  file.name.endsWith('.pptx') ||
                                  file.name.endsWith('.xls') ||
                                  file.name.endsWith('.xlsx') ||
                                  file.name.endsWith('.docx') ||
                                  file.name.endsWith('.doc')
                                  ;
                                if (!isCSV) {
                                  message.error(`You can not upload ${file.type} files!`);
                                }
                                const isLt2M = file.size / 1024 / 1024 < 2;
                                if (!isLt2M) {
                                  message.error('File must be smaller than 2MB!');
                                }
                                return isCSV && isLt2M;
                              }}
                              onChange={(info) => fileUpload(info)}
                              action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'Reporting'}`}
                              headers={{
                                Authorization: Authorization
                              }}
                              showUploadList={false}
                            >
                              <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                                <UploadOutlined /> Upload
                              </Button>
                            </Upload>
                            <Drawer
                              title="Failure Report Uploaded Files"
                              open={showusecasedownloadModal}
                              width={'50%'}
                              onOk={() => setShowusecasedownloadModal(false)}
                              onClose={() => setShowusecasedownloadModal(false)}
                            >
                              <StyledTable size="small"
                                columns={UseCaseColumns}
                                dataSource={
                                  formObject &&
                                    formObject.Attachments &&
                                    Array.isArray(formObject.Attachments) &&
                                    formObject.Attachments
                                    ? [...formObject.Attachments]
                                    : []
                                }
                              />
                            </Drawer>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translation('Status')} name="Status" style={formItemLayout}>
                            <Select
                              disabled={!formObject.Id || selectedKey === 'view'}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Status')}
                              onChange={onStatusChange}
                            >
                              {statusList &&
                                Array.isArray(statusList) &&
                                statusList.map((status, index) => {
                                  return (
                                    <Option key={index} value={status.NextStatus}>
                                      {status.NextStatus}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>

                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Department')}
                            name="DepartmentId"
                            style={formItemLayout}
                          >
                            <Select
                              // mode='multiple'
                              disabled={status === 'Open' || status === 'On hold' || status === 'Reject' || status === 'Close' || selectedKey === 'view'}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Department')}

                              onChange={onChangeDepartment}
                            >
                              {departmentList &&
                                Array.isArray(departmentList) &&
                                departmentList.map((department, index) => {
                                  return (
                                    <Option key={index} value={department.Id}>
                                      {department.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Assign To')}
                            name="UserId"
                            style={formItemLayout}
                          >
                            <Select
                              disabled={status === 'Open' || status === 'On hold' || status === 'Reject' || status === 'Close' || selectedKey === 'view'}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Assign To')}
                            >
                              {usersList &&
                                Array.isArray(usersList) &&
                                usersList.map((user, index) => {
                                  return (
                                    <Option key={index} value={`${user.Id}_${user.RoleId}`}>
                                      {user.UserName_Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            label={translation('Reported By')}
                            name="ReportedBy"
                            style={formItemLayout}
                          >
                            <Select
                              disabled={true}
                              style={{
                                width: '70%'
                              }}
                              placeholder={translation('Select Reported By')}

                            >
                              {userList &&
                                Array.isArray(userList) &&
                                userList.map((user, index) => {
                                  return (
                                    <Option key={index} value={user.Id}>
                                      {user.Name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>

                      </Row>
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                        theme={themeSettings}
                      >
                        <Collapse
                          defaultActiveKey={['1']}
                          style={{ width: '1400px' }}
                          expandIcon={({ isActive }) =>
                            isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                          }
                        >
                          <Panel header="Questions" key="1">
                            <Form
                              name="dynamic_form_nest_item_Reporting"
                              autoComplete="off"
                              form={QuestionRef}
                              initialValues={{ Questions: Questions }}
                              style={{ paddingLeft: '5%', marginBottom: '5%' }}
                              layout="vertical"
                              className="Answers_Form"
                            >
                              <Form.List name="Questions">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ key, name, ...restField }) => (
                                      <Space
                                        key={key}
                                        style={{
                                          display: 'flex',
                                          marginBottom: 50
                                        }}
                                        align="baseline"
                                      >
                                        <Form.Item
                                          label="Question"
                                          {...restField}
                                          name={[name, 'QuestionId']}
                                          rules={[
                                            {
                                              required: true,
                                              message: 'Missing Question'
                                            }
                                          ]}
                                        >
                                          <Select
                                            showSearch
                                            placeholder="Please select Question"
                                            style={{ width: '600px' }}
                                            onChange={(value) => onQuestionChange(value, name)}
                                            disabled={selectedKey === 'view'}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                              option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                          >
                                            {questionsList &&
                                              Array.isArray(questionsList) &&
                                              questionsList.map((item) => {
                                                const isSelectedElsewhere =
                                                  selectedQuestionIds.includes(item.Id) &&
                                                  QuestionRef.getFieldValue(['Questions', name, 'QuestionId']) !== item.Id;
                                                return (
                                                  <Option key={item.Id} value={item.Id} disabled={isSelectedElsewhere}>
                                                    {item.Question}
                                                  </Option>
                                                );
                                              })}

                                          </Select>
                                        </Form.Item>

                                        <Form.Item
                                          {...restField}
                                          label="Answer"
                                          name={[name, 'Answers']}
                                          rules={[
                                            {
                                              required: true,
                                              message: 'Missing Answer'
                                            }
                                          ]}
                                        >
                                          <Input
                                            disabled={selectedKey === 'view'}
                                            placeholder="Please add Answer"
                                            style={{ width: '600px' }}
                                          />
                                        </Form.Item>

                                        {selectedKey === 'view' ?
                                          null : (
                                            <MinusCircleOutlined onClick={() => remove(name)} />
                                          )}
                                      </Space>
                                    ))}

                                    <Form.Item style={{ marginTop: '20px' }}>
                                      <Button
                                        type="dashed"
                                        style={{ width: '500px' }}
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                        disabled={
                                          selectedDevice === null ||
                                            failureTypeId === null ||
                                            selectedKey === 'view'
                                            // ||
                                            // formObject.Id
                                            ? true
                                            : false
                                        }
                                      >
                                        Add Question
                                      </Button>
                                    </Form.Item>
                                  </>
                                )}
                              </Form.List>
                            </Form>
                          </Panel>
                        </Collapse>
                      </div>
                      {/* </div> */}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'right',
                          paddingRight: '5%',
                          paddingTop: '2%'
                        }}
                      >
                        <Form.Item>
                          <Button type="primary" style={{ marginRight: 8 }} htmlType="submit" disabled={selectedKey === 'view'}>
                            Submit
                          </Button>
                        </Form.Item>
                        <Form.Item>
                          <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel} disabled={selectedKey === 'view'}>
                            Cancel
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </TabPane>
                </Tabs>
              )}
              {role && role.key === "Analysis and Corrective Actions" && (
                <Tabs
                  defaultActiveKey="List"
                  activeKey={presentActiveKey}
                // onChange={(activeKey) => {
                //   // setPresentActiveKey('List');
                //   analysisResetFields();
                //   analysisFormResetFields();
                // }}
                >
                  <TabPane tab={'List'} key="List">
                    <StyledTable size="small"
                      columns={FailureAnalysisColumns}
                      dataSource={dataSourceForAnalysis}
                      style={{ marginTop: '24px' }}
                      pagination={{
                        current,
                        onChange: (page) => setCurrent(page),
                      }}
                      onChange={handleTableChange}
                    />
                  </TabPane>
                  <TabPane tab={'Details'} key="Details">
                    <div style={{ padding: '10px 19px' }}>
                      <div style={{ color: 'white', cursor: 'pointer' }}>
                        <Button type='primary' style={{ cursor: 'pointer' }}
                          onClick={() => setPresentActiveKey('List')}
                        >
                          <RollbackOutlined />
                          {translation('Go Back')}
                        </Button>
                      </div>
                    </div>
                    <Form
                      name="FailureReport_Analysis"
                      ref={h2Ref}
                      form={form2}
                      autoComplete="off"
                      initialValues={formObject}
                      layout="vertical"
                      onFinish={onAnalysisFormSubmit}
                      onFinishFailed={onAnalysisFinishFailed}
                      labelWrap
                    // style={{ paddingLeft: '100px' }}
                    >
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2%' }}
                        theme={themeSettings}
                      >
                        <Collapse
                          defaultActiveKey={['1']}
                          style={{ width: '100%' }}
                          expandIcon={({ isActive }) =>
                            isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                          }
                        >
                          <Panel header="Reporting Details" key="1">

                            <div style={{ paddingLeft: '5%' }}>
                              <Row gutter={16}>
                                <Form.Item name="Id"></Form.Item>
                                <Col span={8}>
                                  <Form.Item
                                    name={'Device'}
                                    label={translation(`Equipment`)}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Equipment!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                     <div style={{ display: 'flex', gap: '1%', flexWrap: 'wrap', width: '100%' }}>
                                        <Select
                                          style={{
                                            width: '60%'
                                          }}
                                          value={selectedDevice}
                                          placeholder={translation('Select Equipment')}

                                          disabled={true}
                                        >
                                          {devicesList &&
                                            Array.isArray(devicesList) &&
                                            devicesList.map((eqp, index) => {
                                              return (
                                                <Option key={index} value={eqp.AliasCode}>
                                                  {`${eqp.DisplayCode}`}
                                                </Option>
                                              );
                                            })}
                                        </Select>
                                        <Button
                                          type="primary"
                                          style={{width:'9%'}}
                                          onClick={() => {
                                            setTreeVisible(true);
                                          }}
                                          disabled={formObject.Id}
                                        >
                                          <UpSquareOutlined />
                                        </Button>
                                    </div>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Type')}
                                    name="FailureTypeId"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Failure Type!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Failure Type')}
                                    >
                                      {FailureTypeList &&
                                        Array.isArray(FailureTypeList) &&
                                        FailureTypeList.map((device, index) => {
                                          return (
                                            <Option key={index} value={device.Id}>
                                              {device.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>

                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Fault Code')}
                                    name="FaultCode"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Fault Code!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <Select
                                      style={{
                                        width: '70%'
                                      }}
                                      disabled={formObject.Id}
                                      placeholder={translation('Select Fault Code')}
                                      size="default"
                                    >
                                      {FailureCodeList &&
                                        Array.isArray(FailureCodeList) &&
                                        FailureCodeList.map((FailureCode, index) => {
                                          return (
                                            <Option key={index} value={FailureCode.VendorCode}>
                                              {FailureCode.ParameterDescription}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Severity')}
                                    name="SeverityId"
                                    style={formItemLayout}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Severity!"),
                                      },
                                    ]}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Severity')}
                                    >
                                      {SeverityList &&
                                        Array.isArray(SeverityList) &&
                                        SeverityList.map((device, index) => {
                                          return (
                                            <Option key={index} value={device.Id}>
                                              {device.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Occurred Date&Time')}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Failure Occurred Date&Time!"),
                                      },
                                    ]}
                                    name="OccuranceDate"
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      disabled={formObject.Id}
                                      showTime={{ format: 'HH:mm' }}
                                      placeholder="Select Occurance Date"
                                      inputReadOnly={true}
                                      style={{ width: '70%' }}
                                      format="YYYY-MM-DD HH:mm"
                                      disabledDate={disabledDate}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Occurrence Count')}
                                    name="OccuranceCount"
                                    style={formItemLayout}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please input Failure Occurrence Count!"),
                                      },
                                    ]}
                                  >
                                    <Input
                                      type="number"
                                      onKeyDown={(e) => {
                                        if ([8].includes(e.keyCode)) {
                                          return;
                                        }
                                        if (
                                          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                          (e.keyCode < 96 || e.keyCode > 105)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      disabled={formObject.Id}
                                      placeholder={translation('Failure Occurrence Count')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Description')}
                                    name="FailureDescription"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder={translation('Failure Description')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Impact')}
                                    name="Impact"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder={translation('Add Failure Impact')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Comments')}
                                    name="Comments"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      placeholder={translation('Add Comments')}
                                      style={{ width: '70%' }}
                                      disabled={formObject.Id}
                                    />
                                  </Form.Item>

                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Reported Date')}
                                    name="ReportedDate"
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      format={'YYYY-MM-DD HH:mm'}
                                      style={{ width: '70%' }}
                                      disabled={true}
                                      placeholder={translation('Failure Reported Date')}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    style={formItemLayout}
                                    name="Attachments"
                                    label={translation('Attachments')}
                                  >
                                   <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                          <Button
                                            onClick={() => handleClick('Add New Attachments')}
                                            style={{ width: '34%' }}
                                            disabled={formObject && formObject.Id}>
                                            <CloudUploadOutlined /> Upload files
                                          </Button>
                                          <Button onClick={() => handleClick('View Attachments')} style={{ width: '34%' }}>
                                            <EyeOutlined /> View files
                                          </Button>
                                    </div>
                                    <Upload
                                      multiple={true}
                                      beforeUpload={beforeUpload}
                                      onChange={(info) => fileUpload(info)}
                                      action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'Reporting'}`}
                                      headers={{
                                        Authorization: Authorization
                                      }}
                                      showUploadList={false}
                                    >
                                      <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                                        <UploadOutlined /> Upload
                                      </Button>
                                    </Upload>
                                    <Drawer
                                      title="Failure Report Uploaded Files"
                                      open={showusecasedownloadModal}
                                      width={'50%'}
                                      onOk={() => setShowusecasedownloadModal(false)}
                                      onClose={() => setShowusecasedownloadModal(false)}
                                    >
                                      <StyledTable size="small"
                                        columns={UseCaseColumns}
                                        dataSource={
                                          formObject &&
                                            formObject.Attachments &&
                                            Array.isArray(formObject.Attachments) &&
                                            formObject.Attachments
                                            ? [...formObject.Attachments]
                                            : []
                                        }
                                      />
                                    </Drawer>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={translation('Status')} name="Status" style={formItemLayout}>
                                    <Select
                                      disabled={selectedKey === 'view' || (correctiveButton === true && formObject.Status === 'Analysis Completed')}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Status')}
                                      onChange={onStatusChange}
                                    >
                                      {statusList &&
                                        Array.isArray(statusList) &&
                                        statusList.map((status, index) => {
                                          return (
                                            <Option key={index} value={status.NextStatus}>
                                              {status.NextStatus}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Department')}
                                    name="DepartmentId"
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Department')}
                                      onChange={onChangeDepartment}
                                    >
                                      {departmentList &&
                                        Array.isArray(departmentList) &&
                                        departmentList.map((department, index) => {
                                          return (
                                            <Option key={index} value={department.Id}>
                                              {department.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Assign To')}
                                    name="UserId"
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Assign To')}
                                    >
                                      {usersList &&
                                        Array.isArray(usersList) &&
                                        usersList.map((user, index) => {
                                          return (
                                            <Option key={index} value={`${user.Id}_${user.RoleId}`}>
                                              {user.UserName_Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Reported By')}
                                    name="ReportedBy"
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={true}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Reported By')}

                                    >
                                      {userList &&
                                        Array.isArray(userList) &&
                                        userList.map((user, index) => {
                                          return (
                                            <Option key={index} value={user.Id}>
                                              {user.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <div
                                style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                                theme={themeSettings}
                              >
                                <Collapse
                                  defaultActiveKey={['1']}
                                  style={{ width: '1400px' }}
                                  expandIcon={({ isActive }) =>
                                    isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                                  }
                                >
                                  <Panel header="Questions" key="1">
                                    <Form
                                      name="dynamic_form_nest_item_Analysis"
                                      autoComplete="off"
                                      form={QuestionRef}
                                      initialValues={{ Questions: Questions }}
                                      style={{ paddingLeft: '5%', marginBottom: '5%' }}
                                      layout="vertical"
                                      className="Answers_Form"
                                    >
                                      <Form.List name="Questions">
                                        {(fields, { add, remove }) => (
                                          <>
                                            {fields.map(({ key, name, ...restField }) => (
                                              <Space
                                                key={key}
                                                style={{
                                                  display: 'flex',
                                                  marginBottom: 20
                                                }}
                                                align="baseline"
                                              >
                                                <Form.Item
                                                  label="Question"
                                                  {...restField}
                                                  name={[name, 'QuestionId']}
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'Missing Question'
                                                    }
                                                  ]}
                                                >
                                                  <Select
                                                    showSearch
                                                    placeholder=" Question"
                                                    style={{ width: '600px' }}
                                                    disabled={formObject.Id}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                      option?.children?.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                  >
                                                    {questionsList &&
                                                      Array.isArray(questionsList) &&
                                                      questionsList.map((item, index) => {
                                                        return (
                                                          <option key={index} value={item.Id}>
                                                            {item.Question}
                                                          </option>
                                                        );
                                                      })}
                                                  </Select>
                                                </Form.Item>

                                                <Form.Item
                                                  {...restField}
                                                  label="Answer"
                                                  name={[name, 'Answers']}
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'Missing Answer'
                                                    }
                                                  ]}
                                                >
                                                  <Input
                                                    disabled={formObject.Id}
                                                    placeholder="Answer"
                                                    style={{ width: '600px' }}
                                                  />
                                                </Form.Item>
                                                {!formObject.Id ? (
                                                  <MinusCircleOutlined onClick={() => remove(name)} />
                                                ) : null}
                                              </Space>
                                            ))}
                                            <Form.Item style={{ marginTop: '20px' }}>
                                              <Button
                                                type="dashed"
                                                style={{ width: '500px' }}
                                                onClick={() => add()}
                                                block
                                                icon={<PlusOutlined />}
                                                disabled={
                                                  selectedDevice === null ||
                                                    failureTypeId === null ||
                                                    formObject.Id
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Add Question
                                              </Button>
                                            </Form.Item>
                                          </>
                                        )}
                                      </Form.List>
                                    </Form>
                                  </Panel>
                                </Collapse>
                              </div>
                            </div>
                          </Panel>
                        </Collapse>
                      </div>
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2%'}}
                        theme={themeSettings}
                      >
                        <Collapse
                          // activeKey={this.state.openPanels}
                          defaultActiveKey={['1']}
                          style={{ width: '100%' }}
                          expandIcon={({ isActive }) =>
                            isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                          }
                        // onChange={this.onCollapseChange}
                        >
                          <Panel header="Analysis Details" key="1">

                            <Form
                              name="FailureReport_Analysis_Details"
                              ref={h3Ref}
                              form={form3}
                              autoComplete="off"
                              initialValues={analysisFormObject}
                              layout="vertical"
                              labelWrap
                              style={{ paddingLeft: '5%' }}

                            >
                              {/* <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px', paddingLeft: '4%' }}> */}
                              <Row gutter={16}>

                                <Form.Item name="Id"></Form.Item>
                                <Col span={8}>
                                  <Form.Item
                                    name="AnalysisStartDate"
                                    label={translation(`Analysis Start Date`)}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Analysis Start Date!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      showTime={true}
                                      showNow={false}
                                      disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                                        status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                        || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && analysisFormObject.Id}
                                      placeholder="Select Analysis Start Date"
                                      inputReadOnly={true}
                                      style={{ width: '70%' }}
                                      format="YYYY-MM-DD HH:mm"
                                      // disabledDate={(d) =>
                                      //   !d ||

                                      //   d.isAfter(
                                      //    form3?.getFieldValue('AnalysisDueDate')
                                      //       ? dayjs(form3?.getFieldValue('AnalysisDueDate')).add(1,'day').format('YYYY-MM-DD HH:mm:ss')
                                      //       : ''
                                      //   )
                                      //   &&
                                      //   d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))

                                      // }
                                      disabledDate={(d) => {
                                        // Current date & time
                                        const now = dayjs();

                                        // Get ReportedDate and AnalysisDueDate from the form (as dayjs objects)
                                        const reportedDateValue = form2?.getFieldValue('ReportedDate');
                                        const analysisDueDateValue = form3?.getFieldValue('AnalysisDueDate');
                                        const reportedDate = reportedDateValue ? dayjs(reportedDateValue) : null;
                                        const analysisDueDate = analysisDueDateValue ? dayjs(analysisDueDateValue) : null;

                                        // The minimum allowed date-time is the later of now or ReportedDate
                                        let minDate = now;
                                        if (reportedDate && reportedDate.isAfter(now)) {
                                          minDate = reportedDate;
                                        }

                                        // Disable if:
                                        // - d is before minDate (including time)
                                        // - d is after analysisDueDate (including time)
                                        return (
                                          !d ||
                                          d.add(1, 'day').isBefore(minDate) ||
                                          (analysisDueDate && d.isAfter(analysisDueDate))
                                        );
                                      }}
                                      disabledTime={(current) => {
                                        let FromTime = form2?.getFieldValue('ReportedDate');

                                        let currentTime = dayjs();
                                        if (!FromTime || !current) {
                                          return {};
                                        }
                                        const disabledHours = [];
                                        const disabledMinutes = [];
                                        const disabledSeconds = [];
                                        if (current.isSame(FromTime, 'day')) {
                                          for (let i = 0; i < FromTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === FromTime.hour()) {
                                            for (let i = 0; i < FromTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === FromTime.minute()) {
                                              for (let i = 0; i < FromTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        if (current.isSame(currentTime, 'day')) {
                                          for (let i = 0; i < currentTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === currentTime.hour()) {
                                            for (let i = 0; i < currentTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === currentTime.minute()) {
                                              for (let i = 0; i < currentTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        return {
                                          disabledHours: () => disabledHours,
                                          disabledMinutes: () => disabledMinutes,
                                          disabledSeconds: () => disabledSeconds
                                        };
                                      }}


                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Analysis Due Date')}
                                    name="AnalysisDueDate"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Analysis Due Date!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      showTime={true}
                                      showNow={false}
                                      disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                                        status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                        || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && analysisFormObject.Id}
                                      placeholder="Select Analysis Due Date"
                                      inputReadOnly={true}
                                      style={{ width: '70%' }}
                                      format="YYYY-MM-DD HH:mm"
                                      disabledDate={disabledEndDate}
                                      disabledTime={(current) => {
                                        let FromTime = form3?.getFieldValue('AnalysisStartDate');

                                        let currentTime = dayjs();
                                        if (!FromTime || !current) {
                                          return {};
                                        }
                                        const disabledHours = [];
                                        const disabledMinutes = [];
                                        const disabledSeconds = [];
                                        if (current.isSame(FromTime, 'day')) {
                                          for (let i = 0; i < FromTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === FromTime.hour()) {
                                            for (let i = 0; i < FromTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === FromTime.minute()) {
                                              for (let i = 0; i < FromTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        if (current.isSame(currentTime, 'day')) {
                                          for (let i = 0; i < currentTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === currentTime.hour()) {
                                            for (let i = 0; i < currentTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === currentTime.minute()) {
                                              for (let i = 0; i < currentTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        return {
                                          disabledHours: () => disabledHours,
                                          disabledMinutes: () => disabledMinutes,
                                          disabledSeconds: () => disabledSeconds
                                        };
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    style={formItemLayout}
                                    name="AnalysisAttachments"
                                    label={translation('Analysis Attachments')}
                                  >
                                    <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                          <Button
                                            onClick={() => analysisHandleClick('Add New Attachments')}
                                            style={{ width: '34%' }}
                                            disabled={(status === 'Analysis Completed' && formObject.Id) || (selectedKey === 'view') ||
                                              status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                              || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed'}>
                                            <CloudUploadOutlined /> Upload files
                                          </Button>
                                          <Button onClick={() => analysisHandleClick('View Attachments')} style={{ width: '34%' }}>
                                            <EyeOutlined /> View files
                                          </Button>
                                    </div>
                                    <Upload
                                      multiple={true}
                                      beforeUpload={(file) => {
                                        const isCSV =
                                          file.type === 'image/jpeg' ||
                                          file.name.endsWith('.jpg') ||
                                          file.name.endsWith('.jpeg') ||
                                          file.name.endsWith('.pdf') ||
                                          file.name.endsWith('.png') ||
                                          file.name.endsWith('.ppt') ||
                                          file.name.endsWith('.pptx') ||
                                          file.name.endsWith('.xls') ||
                                          file.name.endsWith('.xlsx') ||
                                          file.name.endsWith('.docx') ||
                                          file.name.endsWith('.doc')
                                          ;
                                        if (!isCSV) {
                                          message.error(`You can not upload ${file.type} files!`);
                                        }
                                        const isLt2M = file.size / 1024 / 1024 < 2;
                                        if (!isLt2M) {
                                          message.error('File must be smaller than 2MB!');
                                        }
                                        return isCSV && isLt2M;
                                      }}
                                      onChange={(info) => analysisFileUpload(info)}
                                      action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'Analysis'}`}
                                      headers={{
                                        Authorization: Authorization
                                      }}
                                      showUploadList={false}
                                    >
                                      <Button style={{ display: 'none' }} ref={myRef1} className="uploadFile">
                                        <UploadOutlined /> Upload
                                      </Button>
                                    </Upload>
                                    <Drawer
                                      title="Failure Analysis Uploaded Files"
                                      open={analysisShowusecasedownloadModal}
                                      width={'50%'}
                                      onOk={() => setAnalysisShowusecasedownloadModal(false)}
                                      onClose={() => setAnalysisShowusecasedownloadModal(false)}
                                    >
                                      <StyledTable size="small"
                                        columns={AnalysisUseCaseColumns}
                                        dataSource={
                                          analysisFormObject &&
                                            analysisFormObject.AnalysisAttachments &&
                                            Array.isArray(analysisFormObject.AnalysisAttachments) &&
                                            analysisFormObject.AnalysisAttachments
                                            ? [...analysisFormObject.AnalysisAttachments]
                                            : []
                                        }
                                      />
                                    </Drawer>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Cause')}
                                    name="FailureCause"
                                    // rules={[
                                    //   {
                                    //     required: true,
                                    //     message: translation("Please Input Failure Cause!"),
                                    //   },
                                    // ]}
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                                        status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                        || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && analysisFormObject.Id}
                                      placeholder="Input Failure Cause"
                                      style={{
                                        width: '70%'
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Contributing Factors')}
                                    name="ContributingFactors"
                                    // rules={[{ required: true }]}
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                                        status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                        || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && analysisFormObject.Id}
                                      placeholder="Input Contributing Factors"
                                      style={{
                                        width: '70%'
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Analysis Description')}
                                    name="AnalysisComments"
                                    // rules={[{ required: true }]}
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                                        status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                        || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && analysisFormObject.Id}
                                      placeholder="Input Analysis Description"
                                      style={{
                                        width: '70%'
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                              </Row>
                              {/* </div> */}
                            </Form>
                          </Panel>
                        </Collapse>
                      </div>
                      {correctiveStatus && correctiveStatus !== null && correctiveStatus === 'Analysis Completed' ?
                        <div
                          style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2%'}}
                          theme={themeSettings}
                        >
                          <Collapse
                            defaultActiveKey={['1']}
                            style={{ width: '100%' }}
                            expandIcon={({ isActive }) =>
                              isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                            }
                          >
                            <Panel header="Corrective Actions" key="1">
                              <Form
                                name="FailureReport_Corrective"
                                ref={h4Ref}
                                form={form4}
                                autoComplete="off"
                                initialValues={correctiveFormObject}
                                layout="vertical"
                                labelWrap
                                style={{ paddingLeft: '5%' }}
                                onFinishFailed={onCorrectiveFinishFailed}
                              >
                                {/* <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px', paddingLeft: '4%' }}> */}
                                <Row gutter={16}>
                                  <Form.Item name="Id"></Form.Item>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Change Recommendations')}
                                      name="ChangeRecommendations"
                                      rules={[
                                        {
                                          required: true,
                                          message: translation("Please Select Change Recommendations!"),
                                        },
                                      ]}
                                      style={formItemLayout}
                                    >
                                      <Select
                                        disabled={selectedKey === 'view'}
                                        style={{
                                          width: '70%'
                                        }}
                                        placeholder="Select Change Recommendations"
                                      >
                                        <Option value={'SECP'}>Software Engineering Change Proposal</Option>
                                        <Option value={'HECP'}>Hardware Engineering Change Proposal</Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Corrective Action Type')}
                                      name="CorrectiveActionType"
                                      rules={[
                                        {
                                          required: true,
                                          message: translation("Please Select Corrective Action Types!"),
                                        },
                                      ]}
                                      style={formItemLayout}
                                    >
                                      <Select
                                        disabled={selectedKey === 'view'}
                                        style={{
                                          width: '70%'
                                        }}
                                        placeholder="Select Corrective Action Type"
                                      >
                                        <Option value={'Design'}>Design</Option>
                                        <Option value={'ShortTerm'}>Short Term</Option>
                                        <Option value={'LongTerm'}>Long Term</Option>

                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>

                                    <Form.Item
                                      style={formItemLayout}
                                      name="CorrectiveActionsAttachments"
                                      label={translation('Corrective Actions Attachments')}
                                    >
                                       <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                            <Button
                                              onClick={() => correctiveHandleClick('Add New Attachments')}
                                              style={{ width: '34%' }}
                                              disabled={selectedKey === 'view'}>
                                              <CloudUploadOutlined /> Upload files
                                            </Button>
                                            <Button onClick={() => correctiveHandleClick('View Attachments')} style={{ width: '34%' }}>
                                              <EyeOutlined /> View files
                                            </Button>
                                      </div>
                                      <Upload
                                        multiple={true}
                                        beforeUpload={(file) => {
                                          const isCSV =
                                            file.type === 'image/jpeg' ||
                                            file.name.endsWith('.jpg') ||
                                            file.name.endsWith('.jpeg') ||
                                            file.name.endsWith('.pdf') ||
                                            file.name.endsWith('.png') ||
                                            file.name.endsWith('.ppt') ||
                                            file.name.endsWith('.pptx') ||
                                            file.name.endsWith('.xls') ||
                                            file.name.endsWith('.xlsx') ||
                                            file.name.endsWith('.docx') ||
                                            file.name.endsWith('.doc')
                                            ;
                                          if (!isCSV) {
                                            message.error(`You can not upload ${file.type} files!`);
                                          }
                                          const isLt2M = file.size / 1024 / 1024 < 2;
                                          if (!isLt2M) {
                                            message.error('File must be smaller than 2MB!');
                                          }
                                          return isCSV && isLt2M;
                                        }}
                                        onChange={(info) => correctiveFileUpload(info)}
                                        action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'CorrectiveActions'}`}
                                        headers={{
                                          Authorization: Authorization
                                        }}
                                        showUploadList={false}
                                      >
                                        <Button style={{ display: 'none' }} ref={myRef2} className="uploadFile">
                                          <UploadOutlined /> Upload
                                        </Button>
                                      </Upload>
                                      <Drawer
                                        title="Corrective Actions Uploaded Files"
                                        open={correctiveShowusecasedownloadModal}
                                        width={'50%'}
                                        onOk={() => setCorrectiveShowusecasedownloadModal(false)}
                                        onClose={() => setCorrectiveShowusecasedownloadModal(false)}
                                      >
                                        <StyledTable size="small"
                                          columns={CorrectiveActionsUseCaseColumns}
                                          dataSource={
                                            correctiveFormObject &&
                                              correctiveFormObject.CorrectiveActionsAttachments &&
                                              Array.isArray(correctiveFormObject.CorrectiveActionsAttachments) &&
                                              correctiveFormObject.CorrectiveActionsAttachments
                                              ? [...correctiveFormObject.CorrectiveActionsAttachments]
                                              : []
                                          }
                                        />
                                      </Drawer>
                                    </Form.Item>

                                  </Col>
                                </Row>
                                <Row gutter={16}>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Planned Corrective Actions')}
                                      name="PlannedCorrectiveActions"
                                      rules={[
                                        {
                                          required: true,
                                          message: translation("Please Input Planned Corrective Actions!"),
                                        },
                                      ]}
                                      style={formItemLayout}
                                    >
                                      <TextArea
                                        disabled={selectedKey === 'view'}
                                        placeholder="Input Planned Corrective Actions"
                                        style={{
                                          width: '70%'
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Implemented Corrective Actions')}
                                      name="ImplementedCorrectiveActions"
                                      // rules={[
                                      //   {
                                      //     required: true,
                                      //     message: translation("Please Input Implemented Corrective Actions!"),
                                      //   },
                                      // ]}
                                      style={formItemLayout}
                                    >
                                      <TextArea
                                        disabled={selectedKey === 'view'}
                                        placeholder="Input Implemented Corrective Actions"
                                        style={{
                                          width: '70%'
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Verification and Validation field remarks')}
                                      name="VerificationAndValidationFieldRemarks"
                                      style={formItemLayout}
                                    >
                                      <TextArea
                                        disabled={selectedKey === 'view'}
                                        placeholder="Input Verification and Validation field remarks"
                                        style={{
                                          width: '70%'
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Form>
                            </Panel>
                          </Collapse>
                        </div>
                        : null}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'right',
                          paddingRight: '5%',
                          paddingTop: '2%'
                        }}
                      >
                        {correctiveButton && correctiveButton === true ?
                          <Form.Item>
                            <Button type="primary" style={{ marginRight: 8 }} onClick={onCorrectiveActionClick}>
                              Proceed to Corrective Actions
                            </Button>
                          </Form.Item>
                          : null}
                        <Form.Item>
                          <Button type="primary" style={{ marginRight: 8 }} htmlType="submit" disabled={(correctiveButton && correctiveButton === true) || selectedKey === 'view'}>
                            Submit
                          </Button>
                        </Form.Item>
                        <Form.Item>
                          <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel} disabled={selectedKey === 'view'}>
                            Cancel
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </TabPane>
                </Tabs>
              )}
              {role && role.key === "Failure Reporting And Assignment(manager)" && (
                <Tabs
                  defaultActiveKey="List"
                  activeKey={presentActiveKey}
                // onChange={(activeKey) => {
                //   // setPresentActiveKey('List');
                //   analysisResetFields();
                // }}
                >
                  <TabPane tab={'List'} key="List">

                    <StyledTable size="small"
                      columns={FailureAnalysisForManagerColumns}
                      dataSource={dataSourceForManager}
                      style={{ marginTop: '24px' }}
                      pagination={{
                        current,
                        onChange: (page) => setCurrent(page),
                      }}
                      onChange={handleTableChange}
                    />
                  </TabPane>
                  <TabPane tab={'Details'} key="Details">
                    <div style={{ padding: '10px 19px' }}>
                      <div style={{ color: 'white', cursor: 'pointer' }}>
                        <Button type='primary' style={{ cursor: 'pointer' }}
                          onClick={() => setPresentActiveKey('List')}
                        >
                          <RollbackOutlined />
                          {translation('Go Back')}
                        </Button>
                      </div>
                    </div>
                    <Form
                      name="FailureReport_Manager"
                      ref={h2Ref}
                      form={form_Manager1}
                      autoComplete="off"
                      initialValues={formObject}
                      layout="vertical"
                      onFinish={onManagerFormSubmit}
                      onFinishFailed={onFinishFailed}
                      labelWrap
                    // style={{ paddingLeft: '100px' }}

                    >
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2%'}}
                        theme={themeSettings}
                      >
                        <Collapse
                          defaultActiveKey={['1']}
                          style={{ width: '100%' }}
                          expandIcon={({ isActive }) =>
                            isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                          }
                        >
                          <Panel header="Reporting Details" key="1">

                            <div style={{ paddingLeft: '5%' }}>
                              <Row gutter={16}>
                                <Form.Item name="Id"></Form.Item>
                                <Col span={8}>
                                  <Form.Item
                                    name={'Device'}
                                    label={translation(`Equipment`)}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Equipment!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                   <div style={{ display: 'flex', gap: '1%', flexWrap: 'wrap', width: '100%' }}>
                                        <Select
                                          style={{
                                            width: '60%'
                                          }}
                                          value={selectedDevice}
                                          placeholder={translation('Select Equipment')}
                                          disabled={true}
                                        >
                                          {devicesList &&
                                            Array.isArray(devicesList) &&
                                            devicesList.map((eqp, index) => {
                                              return (
                                                <Option key={index} value={eqp.AliasCode}>
                                                  {`${eqp.DisplayCode}`}
                                                </Option>
                                              );
                                            })}
                                        </Select>
                                        <Button
                                          type="primary"
                                          style={{width:'9%'}}
                                          onClick={() => {
                                            setTreeVisible(true);
                                          }}
                                          disabled={formObject.Id}
                                        >
                                          <UpSquareOutlined />
                                        </Button>
                                    </div>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Type')}
                                    name="FailureTypeId"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Failure Type!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Failure Type')}
                                    >
                                      {FailureTypeList &&
                                        Array.isArray(FailureTypeList) &&
                                        FailureTypeList.map((device, index) => {
                                          return (
                                            <Option key={index} value={device.Id}>
                                              {device.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>

                                  <Form.Item
                                    label={translation('Fault Code')}
                                    name="FaultCode"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Fault Code!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <Select
                                      style={{
                                        width: '70%'
                                      }}
                                      disabled={formObject.Id}
                                      placeholder={translation('Select Fault Code')}
                                      size="default"
                                    >
                                      {FailureCodeList &&
                                        Array.isArray(FailureCodeList) &&
                                        FailureCodeList.map((FailureCode, index) => {
                                          return (
                                            <Option key={index} value={FailureCode.VendorCode}>
                                              {FailureCode.ParameterDescription}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Severity')}
                                    name="SeverityId"
                                    style={formItemLayout}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Severity!"),
                                      },
                                    ]}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Severity')}
                                    >
                                      {SeverityList &&
                                        Array.isArray(SeverityList) &&
                                        SeverityList.map((device, index) => {
                                          return (
                                            <Option key={index} value={device.Id}>
                                              {device.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Occurred Date&Time')}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Failure Occurred Date&Time!"),
                                      },
                                    ]}
                                    name="OccuranceDate"
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      disabled={formObject.Id}
                                      showTime={{ format: 'HH:mm' }}
                                      placeholder="Select Occurance Date"
                                      inputReadOnly={true}
                                      style={{ width: '70%' }}
                                      format="YYYY-MM-DD HH:mm"
                                      disabledDate={disabledDate}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Occurrence Count')}
                                    name="OccuranceCount"
                                    style={formItemLayout}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please input Failure Occurrence Count!"),
                                      },
                                    ]}
                                  >
                                    <Input
                                      type="number"
                                      onKeyDown={(e) => {
                                        if ([8].includes(e.keyCode)) {
                                          return;
                                        }
                                        if (
                                          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                          (e.keyCode < 96 || e.keyCode > 105)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      disabled={formObject.Id}
                                      placeholder={translation('Failure Occurrence Count')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Description')}
                                    name="FailureDescription"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder={translation('Failure Description')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Impact')}
                                    name="Impact"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder={translation('Add Failure Impact')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Comments')}
                                    name="Comments"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      placeholder={translation('Add Comments')}
                                      style={{ width: '70%' }}
                                      disabled={formObject.Id}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Reported Date')}
                                    name="ReportedDate"
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      format={'YYYY-MM-DD HH:mm'}
                                      style={{ width: '70%' }}
                                      disabled={true}
                                      placeholder={translation('Failure Reported Date')}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    style={formItemLayout}
                                    name="Attachments"
                                    label={translation('Attachments')}
                                  >
                                     <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                          <Button
                                            onClick={() => handleClick('Add New Attachments')}
                                            style={{ width: '34%' }}
                                            disabled={true}>
                                            <CloudUploadOutlined /> Upload files
                                          </Button>
                                          <Button onClick={() => handleClick('View Attachments')} style={{ width: '34%' }}>
                                            <EyeOutlined /> View files
                                          </Button>
                                    </div>
                                    <Upload
                                      multiple={true}
                                      beforeUpload={beforeUpload}
                                      onChange={(info) => fileUpload(info)}
                                      action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'Reporting'}`}
                                      headers={{
                                        Authorization: Authorization
                                      }}
                                      showUploadList={false}
                                    >
                                      <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                                        <UploadOutlined /> Upload
                                      </Button>
                                    </Upload>
                                    <Drawer
                                      title="Failure Report Uploaded Files"
                                      open={showusecasedownloadModal}
                                      width={'50%'}
                                      onOk={() => setShowusecasedownloadModal(false)}
                                      onClose={() => setShowusecasedownloadModal(false)}
                                    >
                                      <StyledTable size="small"
                                        columns={UseCaseColumns}
                                        dataSource={
                                          formObject &&
                                            formObject.Attachments &&
                                            Array.isArray(formObject.Attachments) &&
                                            formObject.Attachments
                                            ? [...formObject.Attachments]
                                            : []
                                        }
                                      />
                                    </Drawer>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={translation('Status')} name="Status" style={formItemLayout}>
                                    <Select
                                      disabled={selectedKey === 'view'}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Status')}
                                      onChange={onStatusChange}
                                    >
                                      {statusList &&
                                        Array.isArray(statusList) &&
                                        statusList.map((status, index) => {
                                          return (
                                            <Option key={index} value={status.NextStatus}>
                                              {status.NextStatus}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>

                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Department')}
                                    name="DepartmentId"
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Department')}
                                      onChange={onChangeDepartment}
                                    >
                                      {departmentList &&
                                        Array.isArray(departmentList) &&
                                        departmentList.map((department, index) => {
                                          return (
                                            <Option key={index} value={department.Id}>
                                              {department.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Assign To')}
                                    name="UserId"
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={formObject.Id}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Assign To')}
                                    >
                                      {usersList &&
                                        Array.isArray(usersList) &&
                                        usersList.map((user, index) => {
                                          return (
                                            <Option key={index} value={`${user.Id}_${user.RoleId}`}>
                                              {user.UserName_Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Reported By')}
                                    name="ReportedBy"
                                    style={formItemLayout}
                                  >
                                    <Select
                                      disabled={true}
                                      style={{
                                        width: '70%'
                                      }}
                                      placeholder={translation('Select Reported By')}
                                    >
                                      {userList &&
                                        Array.isArray(userList) &&
                                        userList.map((user, index) => {
                                          return (
                                            <Option key={index} value={user.Id}>
                                              {user.Name}
                                            </Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>

                              </Row>
                              <div
                                style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
                                theme={themeSettings}
                              >
                                <Collapse
                                  defaultActiveKey={['1']}
                                  style={{ width: '1400px' }}
                                  expandIcon={({ isActive }) =>
                                    isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                                  }
                                >
                                  <Panel header="Questions" key="1">
                                    <Form
                                      name="dynamic_form_nest_item_Manager"
                                      autoComplete="off"
                                      form={QuestionRef}
                                      initialValues={{ Questions: Questions }}
                                      style={{ paddingLeft: '5%', marginBottom: '5%' }}
                                      layout="vertical"
                                      className="Answers_Form"
                                    >
                                      <Form.List name="Questions">
                                        {(fields, { add, remove }) => (
                                          <>
                                            {fields.map(({ key, name, ...restField }) => (
                                              <Space
                                                key={key}
                                                style={{
                                                  display: 'flex',
                                                  marginBottom: 20
                                                }}
                                                align="baseline"
                                              >
                                                <Form.Item
                                                  label="Question"
                                                  {...restField}
                                                  name={[name, 'QuestionId']}
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'Missing Question'
                                                    }
                                                  ]}
                                                >
                                                  <Select
                                                    showSearch
                                                    placeholder=" Question"
                                                    style={{ width: '600px' }}
                                                    disabled={formObject.Id}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                      option?.children?.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                  >
                                                    {questionsList &&
                                                      Array.isArray(questionsList) &&
                                                      questionsList.map((item, index) => {
                                                        return (
                                                          <option key={index} value={item.Id}>
                                                            {item.Question}
                                                          </option>
                                                        );
                                                      })}
                                                  </Select>
                                                </Form.Item>

                                                <Form.Item
                                                  {...restField}
                                                  label="Answer"
                                                  name={[name, 'Answers']}
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'Missing Answer'
                                                    }
                                                  ]}
                                                >
                                                  <Input
                                                    disabled={formObject.Id}
                                                    placeholder="Answer"
                                                    style={{ width: '600px' }}
                                                  />
                                                </Form.Item>
                                                {!formObject.Id ? (
                                                  <MinusCircleOutlined onClick={() => remove(name)} />
                                                ) : null}
                                              </Space>
                                            ))}
                                            <Form.Item style={{ marginTop: '20px' }}>
                                              <Button
                                                type="dashed"
                                                style={{ width: '500px' }}
                                                onClick={() => add()}
                                                block
                                                icon={<PlusOutlined />}
                                                disabled={
                                                  selectedDevice === null ||
                                                    failureTypeId === null ||
                                                    formObject.Id
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Add Question
                                              </Button>
                                            </Form.Item>
                                          </>
                                        )}
                                      </Form.List>
                                    </Form>
                                  </Panel>
                                </Collapse>
                              </div>
                            </div>
                          </Panel>
                        </Collapse>
                      </div>

                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2%'}}
                        theme={themeSettings}
                      >
                        <Collapse
                          defaultActiveKey={['1']}
                          style={{ width: '100%' }}
                          expandIcon={({ isActive }) =>
                            isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                          }
                        >
                          <Panel header="Analysis Details" key="1">

                            <Form
                              name="FailureReport_Analy"
                              ref={h3Ref}
                              form={form_Manager2}
                              autoComplete="off"
                              initialValues={analysisFormObject}
                              layout="vertical"
                              onFinishFailed={onFinishFailed}
                              labelWrap
                              style={{ paddingLeft: '5%' }}

                            >
                              {/* <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px', paddingLeft: '4%' }}> */}
                              <Row gutter={16}>
                                <Form.Item name="Id"></Form.Item>
                                <Col span={8}>
                                  <Form.Item
                                    name="AnalysisStartDate"
                                    label={translation(`Analysis Start Date`)}
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Analysis Start Date!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      showTime={true}
                                      showNow={false}
                                      disabled={formObject.Id}
                                      placeholder="Select Analysis Start Date"
                                      inputReadOnly={true}
                                      style={{ width: '70%' }}
                                      format="YYYY-MM-DD HH:mm"
                                      disabledDate={(d) =>
                                        !d ||
                                        d.isBefore(form2?.getFieldValue() &&
                                          form2?.getFieldValue()['ReportedDate']
                                          ? dayjs(
                                            form2?.getFieldValue()['ReportedDate']
                                          ).subtract(1, 'day').format('YYYY-MM-DD HH:mm')
                                          : ''
                                        )}
                                      disabledTime={(current) => {
                                        let FromTime = form_Manager1?.getFieldValue('ReportedDate');

                                        let currentTime = dayjs();
                                        if (!FromTime || !current) {
                                          return {};
                                        }
                                        const disabledHours = [];
                                        const disabledMinutes = [];
                                        const disabledSeconds = [];
                                        if (current.isSame(FromTime, 'day')) {
                                          for (let i = 0; i < FromTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === FromTime.hour()) {
                                            for (let i = 0; i < FromTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === FromTime.minute()) {
                                              for (let i = 0; i < FromTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        if (current.isSame(currentTime, 'day')) {
                                          for (let i = 0; i < currentTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === currentTime.hour()) {
                                            for (let i = 0; i < currentTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === currentTime.minute()) {
                                              for (let i = 0; i < currentTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        return {
                                          disabledHours: () => disabledHours,
                                          disabledMinutes: () => disabledMinutes,
                                          disabledSeconds: () => disabledSeconds
                                        };
                                      }}
                                    // ||
                                    // d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))

                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Analysis Due Date')}
                                    name="AnalysisDueDate"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation("Please Select Analysis Due Date!"),
                                      },
                                    ]}
                                    style={formItemLayout}
                                  >
                                    <DatePicker
                                      showTime={true}
                                      showNow={false}
                                      disabled={formObject.Id}
                                      placeholder="Select Analysis Due Date"
                                      inputReadOnly={true}
                                      style={{ width: '70%' }}
                                      format="YYYY-MM-DD HH:mm"
                                      disabledDate={disabledEndDate}

                                      disabledTime={(current) => {
                                        let FromTime = form_Manager2?.getFieldValue('AnalysisStartDate');

                                        let currentTime = dayjs();
                                        if (!FromTime || !current) {
                                          return {};
                                        }
                                        const disabledHours = [];
                                        const disabledMinutes = [];
                                        const disabledSeconds = [];
                                        if (current.isSame(FromTime, 'day')) {
                                          for (let i = 0; i < FromTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === FromTime.hour()) {
                                            for (let i = 0; i < FromTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === FromTime.minute()) {
                                              for (let i = 0; i < FromTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        if (current.isSame(currentTime, 'day')) {
                                          for (let i = 0; i < currentTime.hour(); i++) {
                                            disabledHours.push(i);
                                          }
                                          if (current.hour() === currentTime.hour()) {
                                            for (let i = 0; i < currentTime.minute(); i++) {
                                              disabledMinutes.push(i);
                                            }
                                            if (current.minute() === currentTime.minute()) {
                                              for (let i = 0; i < currentTime.second(); i++) {
                                                disabledSeconds.push(i);
                                              }
                                            }
                                          }
                                        }
                                        return {
                                          disabledHours: () => disabledHours,
                                          disabledMinutes: () => disabledMinutes,
                                          disabledSeconds: () => disabledSeconds
                                        };
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    style={formItemLayout}
                                    name="AnalysisAttachments"
                                    label={translation('Analysis Attachments')}
                                  >
                                   <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                          <Button
                                            onClick={() => analysisHandleClick('Add New Attachments')}
                                            style={{ width: '34%' }}
                                            disabled={true}>
                                            <CloudUploadOutlined /> Upload files
                                          </Button>
                                          <Button onClick={() => analysisHandleClick('View Attachments')} style={{ width: '34%' }}>
                                            <EyeOutlined /> View files
                                          </Button>
                                    </div>
                                    <Upload
                                      multiple={true}
                                      beforeUpload={(file) => {
                                        const isCSV =
                                          file.type === 'image/jpeg' ||
                                          file.name.endsWith('.jpg') ||
                                          file.name.endsWith('.jpeg') ||
                                          file.name.endsWith('.pdf') ||
                                          file.name.endsWith('.png') ||
                                          file.name.endsWith('.ppt') ||
                                          file.name.endsWith('.pptx') ||
                                          file.name.endsWith('.xls') ||
                                          file.name.endsWith('.xlsx') ||
                                          file.name.endsWith('.docx') ||
                                          file.name.endsWith('.doc')
                                          ;
                                        if (!isCSV) {
                                          message.error(`You can not upload ${file.type} files!`);
                                        }
                                        const isLt2M = file.size / 1024 / 1024 < 2;
                                        if (!isLt2M) {
                                          message.error('File must be smaller than 2MB!');
                                        }
                                        return isCSV && isLt2M;
                                      }}
                                      onChange={(info) => analysisFileUpload(info)}
                                      action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'Analysis'}`}
                                      headers={{
                                        Authorization: Authorization
                                      }}
                                      showUploadList={false}
                                    >
                                      <Button style={{ display: 'none' }} ref={myRef1} className="uploadFile">
                                        <UploadOutlined /> Upload
                                      </Button>
                                    </Upload>
                                    <Drawer
                                      title="Failure Analysis Uploaded Files"
                                      open={analysisShowusecasedownloadModal}
                                      width={'50%'}
                                      onOk={() => setAnalysisShowusecasedownloadModal(false)}
                                      onClose={() => setAnalysisShowusecasedownloadModal(false)}
                                    >
                                      <StyledTable size="small"
                                        columns={AnalysisUseCaseColumns}
                                        dataSource={
                                          analysisFormObject &&
                                            analysisFormObject.AnalysisAttachments &&
                                            Array.isArray(analysisFormObject.AnalysisAttachments) &&
                                            analysisFormObject.AnalysisAttachments
                                            ? [...analysisFormObject.AnalysisAttachments]
                                            : []
                                        }
                                      />
                                    </Drawer>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={16}>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Failure Cause')}
                                    name="FailureCause"
                                    // rules={[
                                    //   {
                                    //     required: true,
                                    //     message: translation("Please Input Failure Cause!"),
                                    //   },
                                    // ]}
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder="Input Failure Cause"
                                      style={{
                                        width: '70%'
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Contributing Factors')}
                                    name="ContributingFactors"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder="Input Contributing Factors"
                                      style={{
                                        width: '70%'
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    label={translation('Analysis Description')}
                                    name="AnalysisComments"
                                    style={formItemLayout}
                                  >
                                    <TextArea
                                      disabled={formObject.Id}
                                      placeholder="Input Analysis Description"
                                      style={{
                                        width: '70%'
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                              </Row>
                              {/* </div> */}
                            </Form>
                          </Panel>
                        </Collapse>
                      </div>
                      {correctiveStatus && correctiveStatus !== null && correctiveStatus === 'Analysis Completed' ?
                        <div
                          style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2%'}}
                          theme={themeSettings}
                        >
                          <Collapse
                            defaultActiveKey={['1']}
                            style={{ width: '100%' }}
                            expandIcon={({ isActive }) =>
                              isActive ? <MinusCircleOutlined /> : <PlusOutlined />
                            }
                          >
                            <Panel header="Corrective Actions" key="1">
                              <Form
                                name="FailureReport_CA"
                                ref={h4Ref}
                                form={form_Manager3}
                                autoComplete="off"
                                initialValues={correctiveFormObject}
                                layout="vertical"
                                onFinishFailed={onCorrectiveFinishFailed}
                                labelWrap
                                style={{ paddingLeft: '5%' }}

                              >
                                {/* <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px', paddingLeft: '4%' }}> */}
                                <Row gutter={16}>
                                  <Form.Item name="Id"></Form.Item>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Change Recommendations')}
                                      name="ChangeRecommendations"
                                      rules={[
                                        {
                                          required: true,
                                          message: translation("Please Select Change Recommendations!"),
                                        },
                                      ]}
                                      style={formItemLayout}
                                    >
                                      <Select
                                        style={{
                                          width: '70%'
                                        }}
                                        placeholder="Select Change Recommendations"
                                        disabled={(formObject.Id && (status !== 'Verification InProgress' && status !== 'Verification completed'
                                          && status !== 'Corrective Action Proposed' && status !== 'Corrective Action Implemented' && status !== 'Closed'
                                        )) || selectedKey === 'view'}
                                      >
                                        <Option value={'SECP'}>Software Engineering Change Proposal</Option>
                                        <Option value={'HECP'}>Hardware Engineering Change Proposal</Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Corrective Action Type')}
                                      name="CorrectiveActionType"
                                      rules={[
                                        {
                                          required: true,
                                          message: translation("Please Select Corrective Action Types!"),
                                        },
                                      ]}
                                      style={formItemLayout}
                                    >
                                      <Select
                                        disabled={(formObject.Id && (status !== 'Verification InProgress' && status !== 'Verification completed'
                                          && status !== 'Corrective Action Proposed' && status !== 'Corrective Action Implemented' && status !== 'Closed'
                                        )) || selectedKey === 'view'}
                                        style={{
                                          width: '70%'
                                        }}
                                        placeholder="Select Corrective Action Type"
                                      >
                                        <Option value={'Design'}>Design</Option>
                                        <Option value={'ShortTerm'}>Short Term</Option>
                                        <Option value={'LongTerm'}>Long Term</Option>

                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>

                                    <Form.Item
                                      style={formItemLayout}
                                      name="CorrectiveActionsAttachments"
                                      label={translation('Corrective Actions Attachments')}
                                    // rules={[
                                    //   {
                                    //     required: true,
                                    //     message: translation("Corrective Actions Attachments!"),
                                    //   },
                                    // ]}
                                    >
                                     <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                            <Button
                                              onClick={() => correctiveHandleClick('Add New Attachments')}
                                              style={{ width: '34%' }}
                                              disabled={(formObject.Id && (status !== 'Verification InProgress' && status !== 'Verification completed'
                                                && status !== 'Corrective Action Proposed' && status !== 'Corrective Action Implemented' && status !== 'Closed'
                                              )) || selectedKey === 'view'}>
                                              <CloudUploadOutlined /> Upload files
                                            </Button>
                                            <Button onClick={() => correctiveHandleClick('View Attachments')} style={{ width: '34%' }}>
                                              <EyeOutlined /> View files
                                            </Button>
                                      </div>
                                      <Upload
                                        multiple={true}
                                        beforeUpload={(file) => {
                                          const isCSV =
                                            file.type === 'image/jpeg' ||
                                            file.name.endsWith('.jpg') ||
                                            file.name.endsWith('.jpeg') ||
                                            file.name.endsWith('.pdf') ||
                                            file.name.endsWith('.png') ||
                                            file.name.endsWith('.ppt') ||
                                            file.name.endsWith('.pptx') ||
                                            file.name.endsWith('.xls') ||
                                            file.name.endsWith('.xlsx') ||
                                            file.name.endsWith('.docx') ||
                                            file.name.endsWith('.doc')
                                            ;
                                          if (!isCSV) {
                                            message.error(`You can not upload ${file.type} files!`);
                                          }
                                          const isLt2M = file.size / 1024 / 1024 < 2;
                                          if (!isLt2M) {
                                            message.error('File must be smaller than 2MB!');
                                          }
                                          return isCSV && isLt2M;
                                        }}
                                        onChange={(info) => correctiveFileUpload(info)}
                                        action={`${API_FRACAS.SaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'CorrectiveActions'}`}
                                        headers={{
                                          Authorization: Authorization
                                        }}
                                        showUploadList={false}
                                      >
                                        <Button style={{ display: 'none' }} ref={myRef2} className="uploadFile">
                                          <UploadOutlined /> Upload
                                        </Button>
                                      </Upload>
                                      <Drawer
                                        title="Corrective Actions Uploaded Files"
                                        open={correctiveShowusecasedownloadModal}
                                        width={'50%'}
                                        onOk={() => setCorrectiveShowusecasedownloadModal(false)}
                                        onClose={() => setCorrectiveShowusecasedownloadModal(false)}
                                      >
                                        <StyledTable size="small"
                                          columns={CorrectiveActionsUseCaseColumns}
                                          dataSource={
                                            correctiveFormObject &&
                                              correctiveFormObject.CorrectiveActionsAttachments &&
                                              Array.isArray(correctiveFormObject.CorrectiveActionsAttachments) &&
                                              correctiveFormObject.CorrectiveActionsAttachments
                                              ? [...correctiveFormObject.CorrectiveActionsAttachments]
                                              : []
                                          }
                                        />
                                      </Drawer>
                                    </Form.Item>

                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Planned Corrective Actions')}
                                      name="PlannedCorrectiveActions"
                                      rules={[
                                        {
                                          required: true,
                                          message: translation("Please Input Planned Corrective Actions!"),
                                        },
                                      ]}
                                      style={formItemLayout}
                                    >
                                      <TextArea
                                        disabled={(formObject.Id && (status !== 'Verification InProgress' && status !== 'Verification completed'
                                          && status !== 'Corrective Action Proposed' && status !== 'Corrective Action Implemented' && status !== 'Closed'
                                        )) || selectedKey === 'view'}
                                        placeholder="Input Planned Corrective Actions"
                                        style={{
                                          width: '70%'
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Implemented Corrective Actions')}
                                      name="ImplementedCorrectiveActions"
                                      // rules={[
                                      //   {
                                      //     required: true,
                                      //     message: translation("Please Input Implemented Corrective Actions!"),
                                      //   },
                                      // ]}
                                      style={formItemLayout}
                                    >
                                      <TextArea
                                        disabled={(formObject.Id && (status !== 'Verification InProgress' && status !== 'Verification completed'
                                          && status !== 'Corrective Action Proposed' && status !== 'Corrective Action Implemented' && status !== 'Closed'
                                        )) || selectedKey === 'view'}
                                        placeholder="Input Implemented Corrective Actions"
                                        style={{
                                          width: '70%'
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      label={translation('Verification and Validation field remarks')}
                                      name="VerificationAndValidationFieldRemarks"
                                      style={formItemLayout}
                                    >
                                      <TextArea
                                        disabled={(formObject.Id && (status !== 'Verification InProgress' && status !== 'Verification completed'
                                          && status !== 'Corrective Action Proposed' && status !== 'Corrective Action Implemented' && status !== 'Closed'
                                        )) || selectedKey === 'view'}
                                        placeholder="Input Verification and Validation field remarks"
                                        style={{
                                          width: '70%'
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Form>
                            </Panel>
                          </Collapse>
                        </div>
                        : null}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'right',
                          paddingRight: '5%',
                          paddingTop: '2%'
                        }}
                      >
                        <Form.Item>
                          <Button type="primary" style={{ marginRight: 8 }} htmlType="submit" disabled={selectedKey === 'view'}>
                            Submit
                          </Button>
                        </Form.Item>
                        <Form.Item>
                          <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel} disabled={selectedKey === 'view'}>
                            Cancel
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </TabPane>
                </Tabs>
              )}
            </TabPane>
          </>

        ))}
      </Tabs>
      <Modal
        open={questionVisible}
        width={800}
        height={800}
        closable
        title={'Questions'}
        onOk={onQuestionModalsOk}
        onCancel={onQuestionModalCancel}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div
            style={{
              paddingTop: '20px'
              // ,paddingLeft:'200px'
            }}
          >
            <Form
              name="dynamic_form_nest_item"
              autoComplete="off"
              form={QuestionRef}
              initialValues={{ Questions: Questions }}
              style={{ paddingLeft: '5%' }}
              layout="vertical"
              className="Answers_Form"
            >
              <Form.List name="Questions">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          label="Question"
                          {...restField}
                          name={[name, 'QuestionId']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Question'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Question"
                            style={{ width: '350px' }}
                          >
                            {questionsList &&
                              Array.isArray(questionsList) &&
                              questionsList.map((item, index) => {
                                return (
                                  <option key={index} value={item.Id}>
                                    {item.Question}
                                  </option>
                                );
                              })}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          label="Answer"
                          name={[name, 'Answers']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Answer'
                            }
                          ]}
                        >
                          <Input
                            placeholder="Answer"
                            style={{ width: '350px' }}
                          />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        style={{ width: '500px' }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Question
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        </div>
      </Modal>
      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={translation('Equipment')}
        onCancel={() => setTreeVisible(false)}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
      >
        <HierarchyModal
          checkedArray={checkedValue || null}
          treeData={equipmentList && equipmentList !== undefined && Object.values(equipmentList)}
          Key="Rule"
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </StyledHomepage>
  );
};


const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    // userProfile: state.LayoutReducer.userProfile,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
    UserDetails: state.LayoutReducer.UserDetails,
  };
};
export default connect(mapStateToProps)(FailureReports);